PJQ.collections.dailyReports = {};

PJQ.models.dailyReports = {};

PJQ.views.dailyReports = {};

//Routes
PJQ.modules.dailyReports = {
	routes: [
		{
			route: 'projects/:projectId/dailyreports',
			name: 'dailyReports',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "dailyreports");
			}
		},
		{
			route: 'projects/:projectId/dailyreports/:date',
			name: 'dailyReportDate',
			callback: function (projectId, date) {
				if (PJQ.app.module === PJQ.constants.modules.APP) {
					PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "dailyreports", {
						date: PJQ.helpers.dateHelpers.tryParseDateString(date)
					});
				}
				else{
					window.dailyReportDate = date;
					PJQ.modules.pjqProjectWall.initProjectWallAdmin(projectId);
				}
			}
		},
		{
			route: 'projects/:projectId/dailyreports/:date/:tab',
			name: 'dailyReportDateTab',
			callback: function (projectId, date, tab) {
				if (PJQ.app.module === PJQ.constants.modules.APP) {
					PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "dailyreports", {
						date: PJQ.helpers.dateHelpers.tryParseDateString(date),
						tab: tab
					});
				}
				else{
					window.dailyReportDate = date;
					window.dailyReportTab = tab;
					PJQ.modules.pjqProjectWall.initProjectWallAdmin(projectId);
				}
			}
		}
	]
};

PJQ.app.addRoutes(PJQ.modules.dailyReports.routes);
PJQ.models.dailyReports.Attachment = PJQ.models.files.File.extend({
    idAttribute: 'attachmentId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'dailyReports',
                value: this.get('dailyReportId')
            },
            {
                endpoint: 'attachments',
                value: this.id
            }
        ]);
    }
});

PJQ.collections.dailyReports.Attachments = PJQ.collections.files.Files.extend({
    model: PJQ.models.dailyReports.Attachment
});
PJQ.views.dailyReports.AttachmentManagement = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Attachment-Management')
	},
	events: {
		'click .daily-report-attachment': 'attachmentClicked'
	},
	beforeRender: function () {
		this.options.isLocked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT) && this.model.get('status') === 1;
		this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.isAdminAttachments');
		this.options.canEdit = this.model.isNew() || (this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.canAddAttachments') && !this.options.isLocked);
	},
	afterRender: function () {
		this.fileUploader = new PJQ.views.files.FileUploaderGrid({
			el: this.$('.daily-report-attachment-uploader'),
			endpoint: this.model.endpoint() + '/attachments',
			collection: this.model.attachments,
			// includeProjectAttachments: true,
			canUpload: this.options.canEdit,
			canDelete: this.options.isAdmin && this.options.canEdit,
			onSuccess: _.bind(function(file) {
				new PJQ.ajax.Request({
					endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
						{
							endpoint: 'dailyreports',
							value: this.model.id
						},
						{
							endpoint: 'attachments'
						}
					]),
					data: file,
				}).put().done(_.bind(function (file) {
				}, this)).fail(onScriptError);
			}, this),
			onDelete: function (file, callback) {
				new PJQ.views.modals.DeleteCancel({
					header: "Confirm Deletion",
					body: "Are you sure you want to delete this attachment?",
					onDelete: _.bind(function () {
						file.destroy();
						callback();
					}, this)
				});
			}
		});
	},
	attachmentClicked: function (e) {
		let selectedAttachment = this.model.attachments.get($(e.currentTarget).data('cid'));
		this.viewAttachment(selectedAttachment);
	},
	viewAttachment: function (attachment) {
		PJQ.app.view.renderPhotoViewer({
			model: attachment
		});
	}
});

//Models
PJQ.models.dailyReports.CommunicationLog = PJQ.models.BaseModel.extend({
	idAttribute: 'id',
	notifyName: 'Communication Log',
	endpoint: function () {
		let params = null;
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'dailyReports',
				value: this.get('dailyReportId')
			},
			{
				endpoint: 'communicationlogs',
				value: this.id
			}
		], params);
	},
	afterInit: function(){

	},
	parse: function (model) {
		if(model != null){
			if (model.contact) {
				this.contact = new PJQ.models.projectContacts.ProjectContact(model.contact);
			}
			else{
				this.contact = null;
			}

			this.attachments = new PJQ.collections.dailyReports.CommunicationLogAttachments(model.attachments);
			this.attachments.on('update', _.bind(function(){
				this.isDirty = true;
			}, this));
		}
		return model;
	},
	beforeSave: function () {
		this.set('contact', this.contact);
		this.set('attachments', this.attachments.getChangedModels());
	}
});

PJQ.models.dailyReports.CommunicationLogAttachment = PJQ.models.files.File.extend({
	idAttribute: 'attachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'communicationlogs',
				value: this.get('logId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});

//Collections
PJQ.collections.dailyReports.CommunicationLogs = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.CommunicationLog
});

PJQ.collections.dailyReports.CommunicationLogAttachments = PJQ.collections.dailyReports.Attachments.extend({
	model: PJQ.models.dailyReports.CommunicationLogAttachment
});
PJQ.views.dailyReports.CommunicationLogManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'communication-log-management')
    },
    events: {
        'click .btn-add-log': 'addClicked',
        'click .btn-edit-log': 'editClicked',
        'click .btn-delete-log': 'deleteClicked'
    },
    beforeFirstRender: function () {
        this.options.isAdmin = PJQ.app.session.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.isAdminCommunicationLogs');

        this.listenTo(this.collection, 'sync', _.bind(function () {
            this.dataTable.refresh();
        }, this));
    },
    beforeRender: function () {
        this.options.isLocked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT) && this.options.dailyReport.get('status') === 1;
        this.options.canEdit = this.options.project.hasPermission('dailyReports.canAddCommunicationLogs') && !this.options.isLocked;
    },
    renderData: function () {
        return {
            project: this.options.project,
            canEdit: this.options.canEdit
        };
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: '.comm-logs-data-table-container',
            data: this.collection.models,
            isHideSearch: true,
            rowId: "cid",
            order: [1, 'asc'],
            language: {
                zeroRecords: this.options.canEdit ? 'Click "Add Log" to create a new communication log' : 'No communication logs were added for this day'
            },
            onRowDoubleClick: _.bind(function (row) {
                this.editLog(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editLog(row.data());
                        }, this),
                        isShown: _.bind(function () {
                            return this.options.canEdit;
                        }, this)
                    },
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.editLog(row.data());
                        }, this),
                        isShown: _.bind(function () {
                            return !this.options.canEdit;
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: _.bind(function () {
                            return this.options.isAdmin && this.options.canEdit;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.deleteLog(row);
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "data": "attachments",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "50px",
                    "render": function (data) {
                        let attachmentCount = _.size(data.models);
                        return '<div><span class="fal fa-paperclip mr-1 ' + (attachmentCount > 0 ? 'text-success' : 'text-muted') + '"></span><span class="' + (attachmentCount > 0 ? 'text-dark' : 'text-muted') + '">' + attachmentCount.toString() + '</span></div>';
                    }
                },
                {
                    "data": "",
                    "title": "Contact",
                    "searchable": false,
                    "render": function (data, type, row) {
                        let result = 'Not set';
                        if (row.contact != null) {
                            result = PJQ.helpers.contacts.getContactAnchor({
                                id: row.contact.id,
                                name: row.contact.get('companyName')
                            });
                        } else {
                            let name = row.get('name');
                            if (_.size(name) > 0) {
                                result = name;
                            }
                        }
                        return result;
                    }
                },
                {
                    "data": "attributes.time",
                    "title": "Time",
                    "searchable": false,
                    "width": "120px",
                    "render": function (data) {
                        if (data != null) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.TIME);
                        }
                        return 'Not Set';
                    }
                },
                {
                    "data": "attributes.type",
                    "title": "Type",
                    "width": "200px",
                    "render": function (data) {
                        if (data != null) {
                            return PJQ.constants.dailyReports.communicationLogs.typeNames[data];
                        }
                        return "";
                    }
                },
                {
                    "data": "attributes.requiresFollowup",
                    "title": "Requires Follow-up",
                    "width": "180px",
                    "render": function (data) {
                        return data ? 'Yes' : 'No';
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "100px",
                    "render": _.bind(function () {
                        let buttons;
                        if (this.options.canEdit) {
                            buttons = '<button type="button" class="btn btn-info btn-edit-log ht-30p wd-35p mr-1 fs-14"><span class="fal fa-pencil"></span></button>';
                        } else {
                            buttons = '<button type="button" class="btn btn-info btn-edit-log ht-30p wd-35p mr-1 fs-14"><span class="fal fa-search"></span></button>';
                        }
                        if (this.options.isAdmin && this.options.canEdit) {
                            buttons += '<button type="button" class="btn btn-danger btn-delete-log ht-30p wd-35p fs-14"><span class="fal fa-trash"></span></button>';
                        }
                        return '<div class="text-align-right show-on-row-hover" style="width:80px;">' + buttons + '</div>';
                    }, this)
                }
            ]
        });
    },
    addClicked: function () {
        let newLog = new PJQ.models.dailyReports.CommunicationLog({
            dailyReportId: this.options.dailyReport.id,
            time: new Date()
        });
        this.editLog(newLog);
    },
    editClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.editLog(row.data());
    },
    editLog: function (log) {
        new PJQ.views.dailyReports.EditCommunicationLogModal({
            model: log,
            project: this.options.project,
            isLocked: this.options.isLocked,
            onSave: _.bind(function (log) {
                if (log.hasChanged() || log.isNew()) {
                    if (log.isNew()) {
                        this.collection.add(log);
                        this.dataTable.addRow(log);
                    }
                    log.save(null, {
                        notify: true
                    });
                    this.dataTable.refresh();
                }
            }, this),
            onClose: _.bind(function (log) {
                if (log.hasChanged()) {
                    log.fetch({
                        success: _.bind(function () {
                            this.dataTable.refresh();
                        }, this)
                    });
                }
            }, this),
            onDelete: _.bind(function (log) {
                if (log.id > 0) {
                    let row = this.dataTable.getRow(log.cid);
                    this.collection.remove(log);
                    log.destroy();
                    if (row != null) {
                        this.dataTable.removeRow(row);
                    }
                }
            }, this)
        });
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteLog(row);
    },
    deleteLog: function (row) {
        let log = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this communication log?",
            onDelete: _.bind(function () {
                this.collection.remove(log);
                log.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    }
});

PJQ.views.dailyReports.EditCommunicationLogModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'modal-edit-communication-log'),
        maxWidth: 800
    },
    events: {
        'click .btn-save': 'onSave',
        'click .btn-close': 'close',
        'click .btn-delete': 'onDelete'
    },
    beforeModalCreated: function () {
        this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.isAdminCommunicationLogs');
        this.options.canEdit = this.model.isNew() || (this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.canAddCommunicationLogs') && !this.options.isLocked);
    },
    renderData: function () {
        return {
            model: this.model,
            isAdmin: this.options.isAdmin,
            canEdit: this.options.canEdit
        };
    },
    afterRender: function () {
        if (this.options.canEdit) {
            new PJQ.Binder(this.$el, this.model, {
                setDefaultValues: true,
                watchElements: [
                    'input',
                    'textarea'
                ]
            });

            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.log-contact'),
                context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                selectedContact: this.model.contact,
                isSingleChoice: true,
                isReadOnly: !this.options.canEdit,
                addButton: this.$('.btn-edit-contact'),
                onChange: _.bind(function (selectedContact) {
                    this.model.contact = selectedContact;
                    this.model.set('name', '');
                    this.model.isDirty = true;
                    this.renderContact();
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: this.$('.log-type'),
                isIntChoices: true,
                defaultValue: this.model.get('type'),
                isMultiple: false,
                canEdit: this.options.canEdit,
                onChange: _.bind(function (newValue) {
                    this.model.set("type", newValue);
                }, this)
            });
        }
        this.renderContact();

        new PJQ.inputs.Datepicker({
            el: this.$('.log-time'),
            isTimeOnly: true,
            datepickerOptions: {
                defaultDate: this.model.get('time')
            },
            onChange: _.bind(function (newTime) {
                let curTime = this.model.get('time');
                if (curTime == null || PJQ.helpers.dateHelpers.checkTimesDifferent(newTime, new Date(curTime))) {
                    this.model.set('time', newTime);
                }
            }, this)
        });

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.log-file-upload'),
            collection: this.model.attachments,
            canUpload: this.options.canEdit,
            // includeProjectAttachments: true,
            canDelete: this.options.isAdmin && this.options.canEdit,
            previewImageDimension: 150,
            sortDirection: 'asc',
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    attachment.destroy();
                }
                this.model.isDirty = true;
                callback();
            }, this)
        });
    },
    renderContact: function () {
        let $contactSelect = this.$('.log-contact'),
            $contactName = this.$('.log-name');
        if (this.model.contact != null) {
            $contactName.addClass('hidden');
            $contactSelect.removeClass('hidden');
        } else {
            $contactSelect.addClass('hidden');
            $contactName.removeClass('hidden');
        }
    },
    onSave: function () {
        if (this.fileUploader.isUploading()) {
            new PJQ.views.BaseModal({
                header: "Files Uploading",
                body: "You can't save while files are uploading"
            });
        } else {
            if (this.options.onSave) {
                this.options.onSave(this.model);
                this.removeModal();
            }
        }
    },
    close: function () {
        if (this.options.canEdit && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.onSave();
                }, this),
                onDontSave: _.bind(function () {
                    this.onClose(this.model);
                    this.removeModal();
                }, this)
            });
        } else {
            this.onClose(this.model);
            this.removeModal();
        }
    },
    onDelete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this communication log?",
            onDelete: _.bind(function () {
                if (this.options.onDelete) {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});

//Models
PJQ.models.dailyReports.DailyReport = PJQ.models.BaseModel.extend({
	idAttribute: 'dailyReportId',
	endpoint: function () {
		if (this.get('dailyReportId')) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'dailyReports',
					value: this.get('dailyReportId')
				}
			]);
		}
		else {
			if (typeof this.get('reportDate') == null) {
				this.set('reportDate', new Date());
			}
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.get('projectId')
				},
				{
					endpoint: 'dailyReports'
				}
			], [
				{
					parameter: 'reportDate',
					value: PJQ.helpers.dateHelpers.getDateString(this.get('reportDate'), 'yyyy-MM-dd')
				}
			]);
		}
	},
	parse: function (model) {
		model = model ? model : {};

		if (model.weather != null && model.weather.weatherId > 0) {
			this.weather = new PJQ.models.weather.WeatherDay(model.weather);
		}

		if (typeof model.reportDate === 'string') {
			model.reportDate = PJQ.helpers.dateHelpers.parseDateString(model.reportDate, false);
		}
		this.workLogs = new PJQ.collections.dailyReports.WorkLogs(model.workLogs);
		this.notes = new PJQ.collections.dailyReports.Notes(model.notes);
		this.expenses = new PJQ.collections.dailyReports.Expenses(model.expenses);
		this.deliveries = new PJQ.collections.dailyReports.Deliveries(model.deliveries);
		this.communicationLogs = new PJQ.collections.dailyReports.CommunicationLogs(model.communicationLogs);
		this.inspectionLogs = new PJQ.collections.dailyReports.InspectionLogs(model.inspectionLogs);
		this.surveyItems = new PJQ.collections.dailyReports.SurveyItems(model.surveyItems);
		this.attachments = new PJQ.collections.dailyReports.Attachments(_.sortBy(model.attachments, function (attachment) {
			return -attachment.attachmentId;
		}));

		return model;
	},
	getStatusColor: function () {
		let color = '#9E9E9E';
		switch (this.get('status')) {
			case 0:
				color = '#9E9E9E';
				break;
			case 1:
				color = '#4CAF50';
				break;
			case 2:
				color = '#2196F3';
				break;
			case 3:
				color = "#bd2130";
				break;
		}
		return color;
	},
	getStatusName: function () {
		let name;
		switch (this.get('status')) {
			case 0:
				name = 'Not Submitted';
				break;
			case 1:
				name = 'Submitted';
				break;
			case 2:
				name = 'Day Off';
				break;
			case 3:
				name = "Missed";
				break;
		}
		return name;
	},
	exportReport: function (mode, isDownload, settings, callback) {
		new PJQ.ajax.Request({
			endpoint: this.endpoint() + '/export/link' + (_.size(mode) > 0 ? ('?mode=' + mode) : ''),
			data: settings,
			isApi2: true
		}).post().done(_.bind(function (response) {
			if (isDownload) {
				PJQ.files.handleDownload(response);
			}
			callback(response.url);
		}, this)).fail(_.bind(function (xhr, err, result) {
			//todo: error
		}, this));
	},
	updateDelay: function (callback) {
		new PJQ.ajax.Request({
			endpoint: this.endpoint() + '/delay',
			isApi2: true,
			data: this.toJSON()
		}).put().done(_.bind(function (response) {
			callback(response);
		}, this)).fail(_.bind(function (xhr, err, result) {
			//todo: error
		}, this));
	},
	submit: function (signature, callback) {
		new PJQ.ajax.Request({
			endpoint: this.endpoint() + '/submit',
			isApi2: true,
			data: {
				signature: signature
			}
		}).put().done(_.bind(function (response) {
			this.set('status', response.status);
			callback(response);
		}, this)).fail(_.bind(function (xhr, err, result) {
			//todo: error
		}, this));
	},
	share: function (data, callback) {
		new PJQ.ajax.Request({
			endpoint: this.endpoint() + '/share',
			data: {
				subject: data != null ? data.subject : null,
				emails: data != null ? data.emails : null,
			}
		}).post().done(_.bind(function (response) {
			callback(response.url);
		}, this)).fail(_.bind(function (xhr, err, result) {
			//todo: error
		}, this));
	}
});

//Collections
PJQ.collections.dailyReports.DailyReports = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.DailyReport,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'dailyReports'
			}
		], [
			{
				parameter: 'startDate',
				value: PJQ.helpers.dateHelpers.getDateString(this.options.startDate, 'yyyy-MM-dd')
			},
			{
				parameter: 'endDate',
				value: PJQ.helpers.dateHelpers.getDateString(this.options.endDate, 'yyyy-MM-dd')
			}
		]);
	}
});
PJQ.views.dailyReports.DailyReportsNavigator = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Daily-Reports-Navigator'),
        subTemplates: {
            dailyReportDay: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Daily-Report-Day')
        }
    },
    events: {
        'click .daily-report-prev-day': 'previousDay',
        'click .daily-report-next-day': 'nextDay',
        'click .btn-daily-report-day-off': 'setDayOff',
        'click .btn-daily-report-work-day': 'setWorkDay',
        'click .btn-daily-report-submit': 'submitReport',
        'click .btn-daily-report-share': 'share',
        'shown.bs.tab .daily-report-nav-bar': 'tabChanged',
        'click .btn-daily-report-export-all': 'exportAll',
        'click .btn-daily-report-export-report': 'exportReportOnly',
        'click .btn-daily-report-export-attachments': 'exportAttachments',
        'click .btn-daily-report-settings': 'viewSettings',
        'click .btn-daily-report-export-expenses': 'exportExpenses',
        'click .btn-daily-report-export-expenses-excel': 'exportExpensesExcel',
        'click .btn-daily-report-export-all-zip': 'exportAll',
        'click .btn-daily-report-remove-submit': 'removeSubmit',
        'click .btn-daily-report-export-submitted': 'exportAllSubmittedZip',
        'click .btn-daily-report-export-weekly': 'exportWeeklyReport',
        'click .btn-daily-report-log-delays': 'logDelays'
    },
    beforeFirstRender: function () {
        this.hideUnsubmit = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.HIDE_DAILY_REPORT_UNSUBMIT);
        if (this.options.date == null) {
            this.options.date = new Date();
        }

        if (this.model == null) {
            this.model = new PJQ.models.dailyReports.DailyReport({
                reportDate: this.options.date,
                projectId: this.options.project.id
            });
        }
        this.model.fetch();
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            project: this.options.project,
            hideUnsubmit: this.hideUnsubmit
        };
    },
    afterRender: function () {
        this.calendar = new PJQ.views.calendars.MiniCalendar({
            el: this.$('.daily-report-mini-calendar'),
            datepickerOptions: {
                defaultDate: this.options.date
            },
            onChange: _.bind(this.goToDate, this),
            dateRangeChanged: _.bind(function (range) {
                this.renderCalendarStatuses(range);
            }, this)
        });

        if (this.model.id > 0) {
            this.renderDay();
        } else {
            this.listenTo(this.model, 'sync', this.renderDay);
        }
    },
    renderCalendarStatuses: function (range) {
        if (range == null) {
            if (this.calendar == null) {
                return;
            }
            range = this.calendar.getCurrentDateRange();
        }

        let rangeCollection = new PJQ.collections.dailyReports.DailyReports(null, {
            project: this.options.project,
            startDate: range.start,
            endDate: range.end
        });
        rangeCollection.fetch({
            success: _.bind(function () {
                let dates = _.map(rangeCollection.models, function (model) {
                    return {
                        date: model.get('reportDate'),
                        color: model.get('status') === 0 ? null : model.getStatusColor(),
                        textColor: model.get('wasDelayed') ? '#de5a73' : null
                    };
                });
                this.calendar.renderStatusMarkers(dates);
            }, this)
        });
    },
    renderDay: function () {
        this.renderSubTemplate(false, this.options.subTemplates.dailyReportDay, this.$('.daily-report-content'), {
            model: this.model,
            project: this.options.project,
            activeTab: this.options.tab
        });

        let $nav = this.$('.daily-report-nav-bar');
        if (_.size(this.activeTab) > 0) {
            $nav.find('.nav-item>.nav-link[href="' + this.activeTab + '"]').tab('show');
        } else {
            this.activeTab = $nav.find('.nav-item>.nav-link.active').attr('href');
        }

        this.renderStatus();

        this.renderWeather();

        if (this.options.project.hasPermission('dailyReports.canViewWorkLogs')) {
            if (this.workLogManagementView != null) {
                this.workLogManagementView.remove();
            }
            this.workLogManagementView = new PJQ.views.dailyReports.WorkLogManagement({
                el: this.$('#workLogsContainer'),
                collection: this.model.workLogs,
                project: this.options.project,
                dailyReport: this.model
            });
            this.model.workLogs.on('update', _.bind(function () {
                this.$('.badge-work-logs').html(this.model.workLogs.length);
            }, this));
        }

        if (this.options.project.hasPermission('dailyReports.canViewNotes')) {
            if (this.noteManagementView != null) {
                this.noteManagementView.remove();
            }
            this.noteManagementView = new PJQ.views.dailyReports.NoteManagement({
                el: this.$('#notesContainer'),
                collection: this.model.notes,
                project: this.options.project,
                dailyReport: this.model
            });
            this.model.notes.on('update', _.bind(function () {
                this.$('.badge-notes').html(this.model.notes.length);
            }, this));
        }
        if (this.options.project.hasPermission('dailyReports.canViewExpenses') && !this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_DAILY_REPORT_EXPENSES)) {
            if (this.expenseManagementView != null) {
                this.expenseManagementView.remove();
            }
            this.expenseManagementView = new PJQ.views.dailyReports.ExpenseManagement({
                el: this.$('#expensesContainer'),
                collection: this.model.expenses,
                project: this.options.project,
                dailyReport: this.model
            });
            this.model.expenses.on('update', _.bind(function () {
                this.$('.badge-expenses').html(this.model.expenses.length);
            }, this));
        }

        if (this.options.project.hasPermission('dailyReports.canViewDeliveries')) {
            if (this.deliveryManagementView != null) {
                this.deliveryManagementView.remove();
            }
            this.deliveryManagementView = new PJQ.views.dailyReports.DeliveryManagement({
                el: this.$('#deliveryContainer'),
                collection: this.model.deliveries,
                project: this.options.project,
                dailyReport: this.model
            });
            this.model.deliveries.on('update', _.bind(function () {
                this.$('.badge-deliveries').html(this.model.deliveries.length);
            }, this));
        }

        if (this.options.project.hasPermission('dailyReports.canViewCommunicationLogs')) {
            if (this.communicationLogManagementView != null) {
                this.communicationLogManagementView.remove();
            }
            this.communicationLogManagementView = new PJQ.views.dailyReports.CommunicationLogManagement({
                el: this.$('#communicationLogContainer'),
                collection: this.model.communicationLogs,
                project: this.options.project,
                dailyReport: this.model
            });
            this.model.communicationLogs.on('update', _.bind(function () {
                this.$('.badge-communication-logs').html(this.model.communicationLogs.length);
            }, this));
        }

        if (this.options.project.hasPermission('dailyReports.canViewInspectionLogs')) {
            if (this.inspectionLogManagementView != null) {
                this.inspectionLogManagementView.remove();
            }
            this.inspectionLogManagementView = new PJQ.views.dailyReports.InspectionLogManagement({
                el: this.$('#inspectionLogContainer'),
                collection: this.model.inspectionLogs,
                project: this.options.project,
                dailyReport: this.model
            });
            this.model.inspectionLogs.on('update', _.bind(function () {
                this.$('.badge-inspection-logs').html(this.model.inspectionLogs.length);
            }, this));
        }

        if (this.options.project.hasPermission('dailyReports.canViewAttachments')) {
            if (this.attachmentManagementView != null) {
                this.attachmentManagementView.remove();
            }
            this.attachmentManagementView = new PJQ.views.dailyReports.AttachmentManagement({
                el: this.$('#attachmentsContainer'),
                project: this.options.project,
                model: this.model
            });
            this.model.attachments.on('update', _.bind(function () {
                this.$('.badge-attachments').html(this.model.attachments.length);
            }, this));
        }

        if (this.options.project.hasPermission('dailyReports.canViewSurvey')) {
            if (this.surveyView != null) {
                this.surveyView.remove();
            }
            this.surveyView = new PJQ.views.dailyReports.Survey({
                el: this.$('#surveyContainer'),
                project: this.options.project,
                model: this.model
            });
            this.model.surveyItems.on('change', _.bind(function () {
                this.$('.badge-survey').html(_.size(this.model.surveyItems.getCompletedItems()));
            }, this));
        }

        if (this.loader != null) {
            this.loader.remove();
            this.loader = null;
        }
    },
    renderStatus: function () {
        let bgColor = '#9E9E9E',
            statusName = "Loading...";
        if (this.model != null && this.model.id > 0) {
            if (this.model.get('status') !== 0) {
                this.calendar.updateStatusMarker({
                    date: this.model.get('reportDate'),
                    color: this.model.getStatusColor(),
                    textColor: this.model.get('wasDelayed') ? '#de5a73' : null
                });
            }

            let exportButton = this.$('.btn-daily-report-export-outer'),
                shareButton = this.$('.btn-daily-report-share-outer'),
                dayOffButton = this.$('.btn-daily-report-day-off-outer'),
                workDayButton = this.$('.btn-daily-report-work-day-outer'),
                submitButton = this.$('.btn-daily-report-submit-outer'),
                logDelaysButton = this.$('.btn-daily-report-log-delays-outer'),
                removeSubmitButton = this.$('.btn-daily-report-remove-submit-outer');
            if (this.model.get('status') === 1) {
                exportButton.add(shareButton).removeClass('hidden');
                if(!this.hideUnsubmit) {
                    removeSubmitButton.add().removeClass('hidden');
                }
                submitButton.add(dayOffButton).addClass('hidden');
                logDelaysButton.addClass('hidden');
            } else {
                exportButton.removeClass('hidden');
                shareButton.addClass('hidden');
                logDelaysButton.removeClass('hidden');
                if(!this.hideUnsubmit) {
                    removeSubmitButton.add().addClass('hidden');
                }
                submitButton.removeClass('hidden');
                if (this.model.get('status') === 2) {
                    dayOffButton.addClass('hidden');
                    workDayButton.removeClass('hidden');
                } else {
                    workDayButton.addClass('hidden');
                    dayOffButton.removeClass('hidden');
                }
            }
            this.$('.daily-report-buttons').removeClass('invisible');

            bgColor = this.model.getStatusColor();
            statusName = this.model.getStatusName();
        }
        this.$('.daily-report-status').html($('<div>', {
            class: 'text-light text-align-center fs-16 font-weight-light',
            style: 'background-color:' + bgColor
        }).html(statusName));
    },
    removeSubmit: function () {
        new PJQ.views.modals.YesNo({
            header: "Remove Submission?",
            body: "Are you sure you would like to remove submission?",
            onYes: _.bind(function () {
                if (this.model.get('status') === 1) {
                    this.model.set('status', 0);
                }
                this.model.save(null, {
                    success: _.bind(function () {
                        this.render();
                        PJQ.notifications.notify.successNotify({
                            message: 'Successfully Removed Submission!'
                        });
                    }, this)
                })
            }, this)
        });
    },
    renderWeather: function () {
        if (this.model == null || this.model.isNew()) {
            this.$('.weather, .weather-error').addClass('hidden');
        } else {
            let weather = this.model.weather;
            if (weather != null && !weather.isNew()) {
                this.$('.weather-condition-icon').attr('src', weather.conditionIconUrl());
                this.$('.weather-min-temp').html(weather.minTempDisplay());
                this.$('.weather-max-temp').html(weather.maxTempDisplay());
                this.$('.weather-condition').html(weather.get('condition'));
                this.$('.weather').removeClass('hidden');
                this.$('.weather-error').addClass('hidden');
            } else {
                this.$('.weather').addClass('hidden');
                let error = null;
                if (PJQ.helpers.dateHelpers.getDateDiff(this.model.get('reportDate'), new Date(), 'days') + 1 >= PJQ.constants.weather.MAX_FORECAST_DAYS) {
                    error = $("<div>", {
                        class: "m-3"
                    }).html("Weather forecast is limited to 14 days");
                } else {
                    error = $("<div>", {
                        class: "m-1"
                    }).html("Unable to get weather information.  Make sure the project zip code is valid!");
                }
                this.$('.weather-error').html(error);
                this.$('.weather-error').removeClass('hidden');
            }
        }
    },
    tabChanged: function (e) {
        this.activeTab = $(e.target).attr('href');
        switch (this.activeTab) {
            case '#workLogsContainer':
                if (this.workLogManagementView != null && this.workLogManagementView.dataTable != null) {
                    this.workLogManagementView.dataTable.adjust();
                }
                break;
            case '#notesContainer':
                if (this.noteManagementView != null && this.noteManagementView.dataTable != null) {
                    this.noteManagementView.dataTable.adjust();
                }
                break;
            case '#expensesContainer':
                if (this.expenseManagementView != null && this.expenseManagementView.dataTable != null) {
                    this.expenseManagementView.dataTable.adjust();
                }
                break;
            case '#deliveryContainer':
                if (this.deliveryManagementView != null && this.deliveryManagementView.dataTable != null) {
                    this.deliveryManagementView.dataTable.adjust();
                }
                break;
        }
    },
    previousDay: function () {
        this.goToDate(this.model.get('reportDate').addDays(-1));
    },
    nextDay: function () {
        this.goToDate(this.model.get('reportDate').addDays(1));
    },
    goToDate: function (date) {
        this.options.date = date;

        //Keep route up to date
        PJQ.app.router.navigate('projects/' + PJQ.app.session.project.id + '/dailyreports/' + PJQ.helpers.dateHelpers.getDateString(this.options.date, PJQ.helpers.dateHelpers.dateFormats.URL_DATE), {
            trigger: false
        });

        this.loader = new PJQ.Loader(this.$('.daily-report-container'));
        this.model = null;
        this.renderWeather();
        this.renderStatus();
        this.$('.daily-report-buttons').addClass('invisible');
        this.$('.daily-report-date').html(PJQ.helpers.dateHelpers.getDateString(date, 'MM/dd/yyyy'));
        this.calendar.setDate(date);

        this.model = new PJQ.models.dailyReports.DailyReport({
            reportDate: date,
            projectId: this.options.project.id
        });
        this.listenTo(this.model, 'sync', this.renderDay);
        this.model.fetch();
    },
    setDayOff: function () {
        this.model.patch({
            status: PJQ.constants.dailyReports.statuses.DAY_OFF
        }, {
            success: _.bind(function () {
                this.renderStatus();
            }, this)
        });
    },
    setWorkDay: function () {
        this.model.patch({
            status: PJQ.constants.dailyReports.statuses.NOT_SUBMITTED
        }, {
            success: _.bind(function () {
                this.renderStatus();
            }, this)
        });
    },
    validateReport: function () {
        let isValid = this.surveyView.validate();
        if (this.surveyAlert != null) {
            this.surveyAlert.destroy();
        }
        if (!isValid) {
            this.$('.survey-tab').tab('show');
            this.surveyAlert = new PJQ.Alert(this.$('.daily-report-survey'), {
                type: 'danger',
                text: 'Required survey items are not complete',
                isPrepend: true
            });
        }
        return isValid;
    },
    submitReport: function () {
        if (this.validateReport()) {
            new PJQ.views.signatures.SignatureSubmitModal({
                onSubmit: _.bind(function (signature, callback) {
                    this.model.submit(signature, _.bind(function () {
                        this.renderStatus();
                        this.render();
                        callback();
                    }, this));
                }, this)
            });
        }
    },
    exportReportOnly: function () {
        new PJQ.views.dailyReports.DailyReportExportSettingsModal({
            dailyReport: this.model,
            onSave: _.bind(function (model) {
                this.exportReport(null, model)
            }, this)
        });
    },
    exportAll: function () {
        new PJQ.views.dailyReports.DailyReportExportSettingsModal({
            dailyReport: this.model,
            onSave: _.bind(function (model) {
                this.exportReport('all', model)
            }, this)
        });
    },
    exportAttachments: function () {
        new PJQ.views.dailyReports.DailyReportExportSettingsModal({
            dailyReport: this.model,
            onSave: _.bind(function (model) {
                this.exportReport('attachments', model)
            }, this)
        });
    },
    exportReport: function (mode, settings) {
        let loader = new PJQ.Loader(this.$('.btn-daily-report-export'), {
            loadingText: "Exporting..."
        });
        this.model.exportReport(mode, true, settings, function () {
            loader.remove();
        });
    },
    exportAllSubmittedZip: function () {
        let loader = new PJQ.Loader(this.$('.btn-reports'), {
            loadingText: "Exporting..."
        });
        new PJQ.ajax.Request({
            endpoint: this.options.project.endpoint(false) + '/dailyreports/export/submitted',
            isApi2: true
        }).post().done(_.bind(function (response) {
            PJQ.files.handleDownload(response);
            loader.remove();
        }, this)).fail(_.bind(function (xhr, err, result) {
            PJQ.notifications.notify.errorNotify({
                message: 'An error has occurred.'
            });
            loader.remove();
        }, this));
    },
    exportReportsZipByDate: function () {
        new PJQ.views.reporting.GenerateReportModal({
            model: new PJQ.models.reporting.Report({
                id: 'reports',
                name: 'Reports',
                options: [
                    {
                        id: _.unique(),
                        type: 'DATE_RANGE',
                        name: 'Dates',
                        isRequired: true,
                        defaultValue: {
                            from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
                            to: new Date()
                        },
                        value: {
                            from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
                            to: new Date()
                        }
                    }
                ]
            }),
            onDownload: _.bind(function (options, callback) {
                new PJQ.ajax.Request({
                    endpoint: this.options.project.endpoint(false) + '/dailyreports/export/date',
                    data: {
                        options: options,
                        isApi2: true
                    }
                }).post().done(_.bind(function (response) {
                    PJQ.files.downloadFile(response.url, {
                        isEndpoint: false
                    });
                    callback();
                }, this)).fail(_.bind(function (xhr, err, result) {
                    callback();
                }, this));
            }, this)
        });
    },
    exportExpensesExcel: function () {
        new PJQ.views.reporting.GenerateReportModal({
            model: new PJQ.models.reporting.Report({
                id: 'expenses',
                name: 'Expenses',
                options: [
                    {
                        id: _.unique(),
                        type: 'DATE_RANGE',
                        name: 'Dates',
                        isRequired: true,
                        defaultValue: {
                            from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
                            to: new Date()
                        },
                        value: {
                            from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
                            to: new Date()
                        }
                    }
                ]
            }),
            onDownload: _.bind(function (options, callback) {
                new PJQ.ajax.Request({
                    endpoint: this.options.project.endpoint(false) + '/dailyreports/reports/expenses/excel',
                    data: {
                        options: options,
                        isApi2: true
                    }
                }).post().done(_.bind(function (response) {
                    PJQ.files.downloadFile(response.url, {
                        isEndpoint: false
                    });
                    callback();
                }, this)).fail(_.bind(function (xhr, err, result) {
                    callback();
                }, this));
            }, this)
        });
    },
    exportExpenses: function () {
        new PJQ.views.reporting.GenerateReportModal({
            model: new PJQ.models.reporting.Report({
                id: 'expenses',
                name: 'Expenses',
                options: [
                    {
                        id: _.unique(),
                        type: 'DATE_RANGE',
                        name: 'Dates',
                        isRequired: true,
                        defaultValue: {
                            from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
                            to: new Date()
                        },
                        value: {
                            from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
                            to: new Date()
                        }
                    }
                ]
            }),
            onDownload: _.bind(function (options, callback) {
                new PJQ.ajax.Request({
                    endpoint: this.options.project.endpoint(false) + '/dailyreports/reports/expenses',
                    data: {
                        options: options,
                        isApi2: true
                    }
                }).post().done(_.bind(function (response) {
                    PJQ.files.downloadFile(response.url, {
                        isEndpoint: false
                    });
                    callback();
                }, this)).fail(_.bind(function (xhr, err, result) {
                    callback();
                }, this));
            }, this)
        });
    },
    exportWeeklyReport: function () {
        new PJQ.views.dailyReports.DailyReportWeeklyExportModal({
            model: new PJQ.models.reporting.Report({
                id: 'weekly',
                name: 'Weekly',
                options: [
                    {
                        id: _.unique(),
                        type: 'DATE_RANGE',
                        name: 'Dates',
                        isRequired: true,
                        defaultValue: {
                            from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -6),
                            to: new Date()
                        },
                        value: {
                            from: PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), -7),
                            to: new Date()
                        }
                    }
                ]
            }),
            onDownload: _.bind(function (options, callback) {
                new PJQ.ajax.Request({
                    endpoint: this.options.project.endpoint(false) + '/dailyreports/export/weekly',
                    data: {
                        options: options,
                        isApi2: true
                    }
                }).post().done(_.bind(function (response) {
                    PJQ.files.downloadFile(response.url, {
                        isEndpoint: false
                    });
                    callback();
                }, this)).fail(_.bind(function (xhr, err, result) {
                    callback();
                }, this));
            }, this)
        })
    },
    share: function () {
        let sharingModal = new PJQ.views.sharing.SharingModal({
            project: this.options.project,
            subject: 'A Daily Report has been shared with you',
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function (url) {
                    PJQ.notifications.notify.successNotify({
                        message: 'Daily Report share email sent'
                    });
                }, this));
            }, this)
        });
        this.model.exportReport(null, false, null, _.bind(sharingModal.urlChanged, sharingModal));
    },
    viewSettings: function () {
        new PJQ.views.dailyReports.DailyReportSettingsModal({
            project: this.options.project,
            onSave: _.bind(function () {
                this.renderCalendarStatuses();
                this.model.fetch({
                    success: _.bind(function () {
                        this.renderDay();
                    }, this)
                });
            }, this)
        });
    },
    logDelays: function () {
        new PJQ.views.dailyReports.DailyReportLogDelaysModal({
            model: this.model,
            onSave: () => {
                this.renderCalendarStatuses();
            }
        });
    }
});

PJQ.views.dailyReports.DailyReportWeeklyExportModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Modal-Daily-Report-Weekly-Export'),
        subTemplates: {
            exportWeek: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'weekly-export-week'),
        },
        maxWidth: 600,
        onSave: _.noop
    },
    events: {
        'click .weekly-export': 'exportWeekly',
        'click .week-div': 'weekSelected'
    },
    beforeRender: function () {
    },
    renderData: function () {
        return {
            setDefaultValues: true,
            today: new Date(),
            months: ["January", "February", "March", "April", "May", "June", "July",
                "August", "September", "October", "November", "December"],
            model: this.model,
            settings: null
        };
    },
    afterRender: function () {
        let today = new Date();
        this.monthPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.input-select-month'),
            defaultValue: today.getMonth(),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.renderWeeks(value, this.yearPicker.getValue());
            }, this)
        });
        this.yearPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.input-select-year'),
            defaultValue: today.getFullYear(),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.renderWeeks();
            }, this)
        });
        this.startDayPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.input-select-start-day'),
            defaultValue: today.getDay(),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.renderWeeks();
            }, this)
        });
        this.renderWeeks();
    },
    getWeeks: function () {
        let m = this.monthPicker.getValue(),
            y = this.yearPicker.getValue(),
            sd = this.startDayPicker.getValue(),
            d = new Date();
        d.setYear(y)
        d.setMonth(m);
        d.setDate(1);

        let month = d.getMonth(),
            result = [];
        // Get the first "startDay" in the month
        while (d.getDay() !== sd) {
            d.setDate(d.getDate() + 1);
        }

        // Get all the other "startDays" in the month
        while (d.getMonth() === month) {
            result.push(new Date(d.getTime()));
            d.setDate(d.getDate() + 7);
        }

        return result;
    },
    renderWeeks: function () {
        this.setSelectedWeek(null);
        this.weeks = this.getWeeks();

        let $choices = this.$('.week-choices-container');
        $choices.empty();
        _.each(this.weeks, function (week, ix) {
            this.renderSubTemplate(true, this.options.subTemplates.exportWeek, $choices, {
                weekNumber: ix,
                dates: PJQ.helpers.dateHelpers.getDateString(week, PJQ.helpers.dateHelpers.dateFormats.DATE) + ' - ' + PJQ.helpers.dateHelpers.getDateString(PJQ.helpers.dateHelpers.getNewDateAddDays(week, 6), PJQ.helpers.dateHelpers.dateFormats.DATE)
            });
        }, this);
    },
    weekSelected: function (e) {
        this.$('.weekly-export').attr('disabled', false);

        let $target = $(e.currentTarget);
        this.setSelectedWeek($target.data().week)
    },
    setSelectedWeek: function (week) {
        this.selectedWeek = week;

        this.$el.find('.week-div').removeClass('week-select');
        this.$el.find('.select-week').removeClass('fa-check-square').addClass('fa-square');
        this.$('.weekly-export').attr('disabled', this.selectedWeek == null);
        if (this.selectedWeek != null) {
            let $selected = this.$('.week-div[data-week="' + this.selectedWeek + '"]')
            $selected.addClass('week-select');
            $selected.find('.select-week').removeClass('fa-square').addClass('fa-check-square');
        }
    },
    exportWeekly: function () {
        if (this.selectedWeek == null) {
            return;
        }

        let weekObj = this.weeks[this.selectedWeek],
            startDay = PJQ.helpers.dateHelpers.getNewDateAddDays(PJQ.helpers.dateHelpers.getDateString(weekObj, PJQ.helpers.dateHelpers.dateFormats.DATE), 0),
            endDay = PJQ.helpers.dateHelpers.getNewDateAddDays(startDay, 6),
            options = this.model.get('options');
        options[0].value.from = startDay;
        options[0].value.to = endDay;

        // let isExportWorkLogs = this.$('.input-export-work-logs').prop('checked'),
        //     isExportNotes = this.$('.input-export-notes').prop('checked'),
        //     isExportExpenses = this.$('.input-export-expenses').prop('checked'),
        //     isExportSurvey = this.$('.input-export-survey').prop('checked'),
        //     isExportDeliveries = this.$('.input-export-deliveries').prop('checked'),
        //     isExportCommunications = this.$('.input-export-communications').prop('checked'),
        //     isExportInspections = this.$('.input-export-inspections').prop('checked'),
        //     isExportAttachments = this.$('.input-export-attachments').prop('checked'),
        //     isExportWeather = this.$('.input-export-weather').prop('checked'),

        if (typeof this.options.onDownload === 'function') {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.options.onDownload(this.model.get('options'), _.bind(function () {
                loader.remove();
                this.removeModal();
            }, this));
        }
    }
});

PJQ.views.dailyReports.DailyReportLogDelaysModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'modal-daily-report-log-delays'),
        maxWidth: 600,
        onSave: _.noop
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-close': 'close'
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input',
                'textarea'
            ],
            afterChange: _.bind(function ($field) {
                if($field.hasClass('was-delayed')) {
                    this.render();
                }
            }, this)
        });
    },
    save: function () {
        if(!this.model.get('wasDelayed')) {
            this.model.set('delayReason', '');
        }

        this.$('.btn-save').attr('disabled', true);
        let loader = new PJQ.Loader(this.$('.modal-content'));
        this.model.updateDelay(() => {
            loader.remove()
            this.removeModal();
            if(typeof this.options.onSave === 'function') {
                this.options.onSave();
            }
        })
    },
    close: function() {
        this.model.restore();
        this.removeModal();
    }
});

//Models
PJQ.models.dailyReports.Delivery = PJQ.models.BaseModel.extend({
	idAttribute: 'deliveryId',
	notifyName: 'Delivery',
	endpoint: function () {
		let params = null;
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'dailyReports',
				value: this.get('dailyReportId')
			},
			{
				endpoint: 'deliveries',
				value: this.id
			}
		], params);
	},
	afterInit: function(){

	},
	parse: function (model) {
		if(model != null){
			if (model.deliveryFrom) {
				this.deliveryFrom = new PJQ.models.projectContacts.ProjectContact(model.deliveryFrom);
			}
			else{
				this.deliveryFrom = null;
			}

			this.attachments = new PJQ.collections.dailyReports.DeliveryAttachments(model.attachments);
			this.attachments.on('update', _.bind(function(){
				this.isDirty = true;
			}, this));
		}
		return model;
	},
	beforeSave: function () {
		this.set('deliveryFrom', this.deliveryFrom);
		this.set('attachments', this.attachments.getChangedModels());
	}
});

PJQ.models.dailyReports.DeliveryAttachment = PJQ.models.files.File.extend({
	idAttribute: 'attachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'delivery',
				value: this.get('deliveryId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});


//Collections
PJQ.collections.dailyReports.Deliveries = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.Delivery
});

PJQ.collections.dailyReports.DeliveryAttachments = PJQ.collections.dailyReports.Attachments.extend({
	model: PJQ.models.dailyReports.DeliveryAttachment
});
PJQ.views.dailyReports.DeliveryManagement = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Delivery-Management')
	},
	events: {
		'click .add-delivery': 'addClicked',
		'click .edit-delivery': 'editClicked',
		'click .delete-delivery': 'deleteClicked'
	},
	beforeFirstRender: function () {
		this.options.isAdmin = PJQ.app.session.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.isAdminDeliveries');

		this.listenTo(this.collection, 'sync', _.bind(function () {
			this.dataTable.refresh();
		}, this));
	},
	beforeRender: function () {
		this.options.isLocked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT) && this.options.dailyReport.get('status') === 1;
		this.options.canEdit = this.options.project.hasPermission('dailyReports.canAddDeliveries') && !this.options.isLocked;
	},
	renderData: function () {
		return {
			project: this.options.project,
			canEdit: this.options.canEdit
		};
	},
	afterRender: function () {
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: '.delivery-data-table-container',
			data: this.collection.models,
			isHideSearch: true,
			rowId: "cid",
			order: [1, 'asc'],
			language: {
				zeroRecords: this.options.canEdit ? 'Click "Add Delivery" to create a new delivery' : 'No deliveries were added for this day'
			},
			onRowDoubleClick: _.bind(function (row) {
				this.editDelivery(row.data());
			}, this),
			contextMenuOptions: {
				actions: [
					{
						name: 'Edit',
						onClick: _.bind(function (row) {
							this.editDelivery(row.data());
						}, this),
						isShown: _.bind(function () {
							return this.options.canEdit;
						}, this)
					},
					{
						name: 'View',
						onClick: _.bind(function (row) {
							this.editDelivery(row.data());
						}, this),
						isShown: _.bind(function () {
							return !this.options.canEdit;
						}, this)
					},
					{
						name: 'Delete',
						isDanger: true,
						isShown: _.bind(function () {
							return this.options.isAdmin && this.options.canEdit;
						}, this),
						onClick: _.bind(function (row) {
							this.deleteDelivery(row);
						}, this)
					}
				]
			},
			columns: [
				{
					"data": "attachments",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": "50px",
					"render": function (data) {
						let attachmentCount = _.size(data.models);
						return '<div><span class="fal fa-paperclip mr-1 ' + (attachmentCount > 0 ? 'text-success' : 'text-muted') + '"></span><span class="' + (attachmentCount > 0 ? 'text-dark' : 'text-muted') + '">' + attachmentCount.toString() + '</span></div>';
					}
				},
				{
					"data": "",
					"title": "From",
					"searchable": false,
					"render": function (data, type, row) {
						let result = 'Not set';
						if (row.deliveryFrom != null) {
							result = PJQ.helpers.contacts.getContactAnchor({
								id: row.deliveryFrom.id,
								name: row.deliveryFrom.get('companyName')
							});
						}
						else {
							let deliveryFromName = row.get('deliveryFromName');
							if (_.size(deliveryFromName) > 0) {
								result = deliveryFromName;
							}
						}
						return result;
					}
				},
				{
					"data": "attributes.time",
					"title": "Time",
					"searchable": false,
					"width": "120px",
					"render": function (data) {
						if (data != null) {
							return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.TIME);
						}
						return 'Not Set';
					}
				},
				{
					"data": "attributes.trackingNumber",
					"title": "Tracking Number",
					"width": "200px"
				},
				{
					"data": "attributes.purchaseOrderNumber",
					"title": "PO Number",
					"width": "150px"
				},
				{
					"data": "attributes.contents",
					"title": "Contents",
					"orderable": false
				},
				{
					"data": "",
					"title": "",
					"orderable": false,
					"searchable": false,
					resizable: false,
					"width": "100px",
					"render": _.bind(function () {
						let buttons;
						if (this.options.canEdit) {
							buttons = '<button type="button" class="btn btn-info edit-delivery ht-30p wd-35p mr-1 fs-14"><span class="fal fa-pencil"></span></button>';
						}
						else {
							buttons = '<button type="button" class="btn btn-info edit-delivery ht-30p wd-35p mr-1 fs-14"><span class="fal fa-search"></span></button>';
						}
						if (this.options.isAdmin && this.options.canEdit) {
							buttons += '<button type="button" class="btn btn-danger delete-delivery ht-30p wd-35p fs-14"><span class="fal fa-trash"></span></button>';
						}
						return '<div class="text-align-right show-on-row-hover" style="width:80px;">' + buttons + '</div>';
					}, this)
				}
			]
		});
	},
	addClicked: function () {
		let newDelivery = new PJQ.models.dailyReports.Delivery({
			dailyReportId: this.options.dailyReport.id,
			time: new Date(),
			trackingNumber: '',
			purchaseOrderNumber: '',
			contents: '',
			notes: ''
		});
		this.editDelivery(newDelivery);
	},
	editClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr'));
		this.editDelivery(row.data());
	},
	editDelivery: function (delivery) {
		new PJQ.views.dailyReports.EditDeliveryModal({
			model: delivery,
			project: this.options.project,
			isLocked: this.options.isLocked,
			onSave: _.bind(function (delivery) {
				if (delivery.hasChanged() || delivery.isNew()) {
					if (delivery.isNew()) {
						this.collection.add(delivery);
						this.dataTable.addRow(delivery);
					}
					delivery.save(null, {
						notify: true
					});
					this.dataTable.refresh();
				}
			}, this),
			onClose: _.bind(function (delivery) {
				if (delivery.hasChanged()) {
					delivery.fetch({
						success: _.bind(function () {
							this.dataTable.refresh();
						}, this)
					});
				}
			}, this),
			onDelete: _.bind(function (delivery) {
				if (delivery.id > 0) {
					let row = this.dataTable.getRow(delivery.cid);
					this.collection.remove(delivery);
					delivery.destroy();
					if (row != null) {
						this.dataTable.removeRow(row);
					}
				}
			}, this)
		});
	},
	deleteClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr'));
		this.deleteDelivery(row);
	},
	deleteDelivery: function (row) {
		let delivery = row.data();
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this delivery?",
			onDelete: _.bind(function () {
				this.collection.remove(delivery);
				delivery.destroy();
				this.dataTable.removeRow(row);
			}, this)
		});
	}
});

PJQ.views.dailyReports.EditDeliveryModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Modal-Edit-Delivery'),
		maxWidth: 800
	},
	events: {
		'click .delivery-from-edit': 'editDeliveryFrom',
		'click .delivery-save': 'onSave',
		'click .delivery-close': 'close',
		'click .delivery-delete': 'onDelete'
	},
	beforeModalCreated: function () {
		this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.isAdminDeliveries');
		this.options.canEdit = this.model.isNew() || (this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.canAddDeliveries') && !this.options.isLocked);
	},
	renderData: function () {
		return {
			model: this.model,
			isAdmin: this.options.isAdmin,
			canEdit: this.options.canEdit
		};
	},
	afterRender: function () {
		if (this.options.canEdit) {
			new PJQ.Binder(this.$el, this.model, {
				watchElements: [
					'input',
					'textarea'
				]
			});

			new PJQ.views.contacts.ContactsSelectInput({
				el: this.$('.delivery-from'),
				context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
				selectedContact: this.model.deliveryFrom,
				isSingleChoice: true,
				isReadOnly: !this.options.canEdit,
				addButton: this.$('.btn-edit-delivery-from'),
				onChange: _.bind(function (selectedContact) {
					this.model.deliveryFrom = selectedContact;
					this.model.set('deliveryFromName', '');
					this.model.isDirty = true;
					this.renderDeliveryFrom();
				}, this)
			});
		}
		this.renderDeliveryFrom();

		new PJQ.inputs.Datepicker({
			el: this.$('.delivery-time'),
			isTimeOnly: true,
			datepickerOptions: {
				defaultDate: this.model.get('time')
			},
			onChange: _.bind(function (newTime) {
				let currentDeliveryTime = this.model.get('time');
				if (currentDeliveryTime == null || PJQ.helpers.dateHelpers.checkTimesDifferent(newTime, new Date(currentDeliveryTime))) {
					this.model.set('time', newTime);
				}
			}, this)
		});

		this.fileUploader = new PJQ.views.files.FileUploaderGrid({
			el: this.$('.delivery-file-upload'),
			collection: this.model.attachments,
			canUpload: this.options.canEdit,
			// includeProjectAttachments: true,
			canDelete: this.options.isAdmin && this.options.canEdit,
			previewImageDimension: 150,
			sortDirection: 'asc',
			onDelete: _.bind(function (attachment, callback) {
				if (attachment.id > 0) {
					attachment.set('isDeleted', true);
				}
				else {
					attachment.destroy();
				}
				this.model.isDirty = true;
				callback();
			}, this)
		});
	},
	renderDeliveryFrom: function () {
		let $contactSelect = this.$('.delivery-from'),
			$contactName = this.$('.delivery-from-name');
		if (this.model.deliveryFrom != null) {
			$contactName.addClass('hidden');
			$contactSelect.removeClass('hidden');
		}
		else {
			$contactSelect.addClass('hidden');
			$contactName.removeClass('hidden');
		}
	},
	onSave: function () {
		if (this.fileUploader.isUploading()) {
			new PJQ.views.BaseModal({
				header: "Files Uploading",
				body: "You can't save while files are uploading"
			});
		}
		else {
			if (this.options.onSave) {
				this.options.onSave(this.model);
				this.removeModal();
			}
		}
	},
	close: function () {
		if (this.options.canEdit && this.model.hasChanged()) {
			new PJQ.views.modals.SaveDontSave({
				header: "Unsaved Changes",
				body: "Do you want to save changes?",
				onSave: _.bind(function () {
					this.onSave();
				}, this),
				onDontSave: _.bind(function () {
					this.onClose(this.model);
					this.removeModal();
				}, this)
			});
		}
		else {
			this.onClose(this.model);
			this.removeModal();
		}
	},
	onDelete: function () {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this delivery?",
			onDelete: _.bind(function () {
				if (this.options.onDelete) {
					this.options.onDelete(this.model);
				}
				this.removeModal();
			}, this)
		});
	}
});

//Models
PJQ.models.dailyReports.Expense = PJQ.models.BaseModel.extend({
	idAttribute: 'expenseId',
	notifyName: 'Expense',
	endpoint: function () {
		let params = null;
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'dailyReports',
				value: this.get('dailyReportId')
			},
			{
				endpoint: 'expenses',
				value: this.id
			}
		], params);
	},
	afterInit: function(){
		this.on('change:group', _.bind(function(){
			let newGroup = this.get('group');
			if(newGroup instanceof PJQ.models.groups.Group){
				this.group = newGroup;
			}
			else if(newGroup != null && typeof newGroup === 'object'){
				this.group = new PJQ.models.groups.Group(newGroup);
			}
			else{
				this.group = null;
			}
		}, this));
	},
	parse: function (model) {
		if(model != null){
			this.attachments = new PJQ.collections.dailyReports.ExpenseAttachments(model.attachments);
			this.attachments.on('update', _.bind(function(){
				this.isDirty = true;
			}, this));

			if(model.group != null){
				this.group = new PJQ.models.groups.Group(model.group);
			}
		}
		return model;
	},
	beforeSave: function () {
		this.set('attachments', this.attachments.getChangedModels());
		this.set('group', this.group);
	}
});

PJQ.models.dailyReports.ExpenseAttachment = PJQ.models.files.File.extend({
	idAttribute: 'expenseAttachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'expenses',
				value: this.get('expenseId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});


//Collections
PJQ.collections.dailyReports.Expenses = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.Expense
});

PJQ.collections.dailyReports.ExpenseAttachments = PJQ.collections.dailyReports.Attachments.extend({
	model: PJQ.models.dailyReports.ExpenseAttachment
});
PJQ.views.dailyReports.ExpenseManagement = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Expense-Management')
	},
	events: {
		'click .add-expense': 'addClicked',
		'click .edit-expense': 'editClicked',
		'click .delete-expense': 'deleteClicked'
	},
	beforeFirstRender: function () {
		this.options.isAdmin = PJQ.app.session.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.isAdminExpenses');

		this.listenTo(this.collection, 'sync', _.bind(function () {
			this.dataTable.refresh();
		}, this));
	},
	beforeRender: function () {
		this.options.isLocked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT) && this.options.dailyReport.get('status') === 1;
		this.options.canEdit = this.options.project.hasPermission('dailyReports.canAddExpenses') && !this.options.isLocked;
	},
	renderData: function () {
		return {
			project: this.options.project,
			canEdit: this.options.canEdit
		};
	},
	afterRender: function () {
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: '.expenses-data-table-container',
			data: this.collection.models,
			isHideSearch: true,
			rowId: "cid",
			order: [1, 'asc'],
			language: {
				zeroRecords: this.options.canEdit ? 'Click "Add Expense" to create a new expense' : 'No expenses were added for this day'
			},
			onRowDoubleClick: _.bind(function (row) {
				this.editExpense(row.data());
			}, this),
			contextMenuOptions: {
				actions: [
					{
						name: 'Edit',
						onClick: _.bind(function (row) {
							this.editExpense(row.data());
						}, this),
						isShown: _.bind(function () {
							return this.options.canEdit;
						}, this)
					},
					{
						name: 'View',
						onClick: _.bind(function (row) {
							this.editExpense(row.data());
						}, this),
						isShown: _.bind(function () {
							return !this.options.canEdit;
						}, this)
					},
					{
						name: 'Delete',
						isDanger: true,
						isShown: _.bind(function () {
							return this.options.isAdmin && this.options.canEdit;
						}, this),
						onClick: _.bind(function (row) {
							this.deleteExpense(row);
						}, this)
					}
				]
			},
			columns: [
				{
					"data": "attachments",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": "50px",
					"render": function (data) {
						let attachmentCount = _.size(data.models);
						return '<div><span class="fal fa-paperclip mr-1 ' + (attachmentCount > 0 ? 'text-success' : 'text-muted') + '"></span><span class="' + (attachmentCount > 0 ? 'text-dark' : 'text-muted') + '">' + attachmentCount.toString() + '</span></div>';
					}
				},
				{"data": "attributes.description", "title": "Description"},
				{
					"data": "attributes.cost",
					"title": "Cost",
					"searchable": false,
					"width": "100px",
					"render": function (data) {
						return PJQ.helpers.formatHelpers.formatCurrency(data, 2, true);
					}
				},
				{
					"data": "group",
					"title": "Cost Code",
					"width": "200px",
					"render": function (data) {
						if (data) {
							return data.get('groupName');
						}
						return '';
					}
				},
				{
					"data": "attributes.notes",
					"title": "Notes",
					"orderable": false,
					"searchable": false
				},
				{
					"data": "",
					"title": "",
					"orderable": false,
					"searchable": false,
					resizable: false,
					"width": "100px",
					"render": _.bind(function () {
						let buttons;
						if (this.options.canEdit) {
							buttons = '<button type="button" class="btn btn-info edit-expense ht-30p wd-35p mr-1 fs-14"><span class="fal fa-pencil"></span></button>';
						}
						else {
							buttons = '<button type="button" class="btn btn-info edit-expense ht-30p wd-35p mr-1 fs-14"><span class="fal fa-search"></span></button>';
						}
						if (this.options.isAdmin && this.options.canEdit) {
							buttons += '<button type="button" class="btn btn-danger delete-expense ht-30p wd-35p fs-14"><span class="fal fa-trash"></span></button>';
						}
						return '<div class="text-align-right show-on-row-hover" style="width:80px;">' + buttons + '</div>';
					}, this)
				}
			]
		});
	},
	addClicked: function () {
		let newExpense = new PJQ.models.dailyReports.Expense({
			dailyReportId: this.options.dailyReport.id,
			description: "",
			cost: 0,
			notes: ""
		});
		this.editExpense(newExpense);
	},
	editClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr')),
			expense = row.data();
		this.editExpense(expense);
	},
	editExpense: function (expense) {
		new PJQ.views.dailyReports.EditExpenseModal({
			model: expense,
			isLocked: this.options.isLocked,
			project: this.options.project,
			onSave: _.bind(function (expense) {
				if (expense.hasChanged() || expense.isNew()) {
					if (expense.isNew()) {
						this.collection.add(expense);
						this.dataTable.addRow(expense);
					}
					expense.save(null, {
						notify: true
					});
					this.dataTable.refresh();
				}
			}, this),
			onClose: _.bind(function (expense) {
				if (expense.hasChanged()) {
					expense.fetch({
						success: _.bind(function () {
							this.dataTable.refresh();
						}, this)
					});
				}
			}, this),
			onDelete: _.bind(function (expense) {
				if (expense.id > 0) {
					let row = this.dataTable.getRow(expense.cid);
					this.collection.remove(expense);
					expense.destroy();
					if (row != null) {
						this.dataTable.removeRow(row);
					}
				}
			}, this)
		});
	},
	deleteClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr'));
		this.deleteExpense(row);
	},
	deleteExpense: function (row) {
		let expense = row.data();
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this expense?",
			onDelete: _.bind(function () {
				this.collection.remove(expense);
				expense.destroy();
				this.dataTable.removeRow(row);
			}, this)
		});
	}
});

PJQ.views.dailyReports.EditExpenseModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Modal-Edit-Expense'),
		maxWidth: 800,
		subTemplates: {
			groupBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Groups-Select-Input-Groups')
		},
		isShowCloseButton: true
	},
	events: {
		'click .expense-save': 'onSave',
		'click .expense-close': 'close',
		'click .btn-expense-edit-group': 'editGroup',
		'click .group-select-input-delete': 'deleteGroup',
		'click .expense-delete': 'onDelete'
	},
	beforeModalCreated: function () {
		this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.isAdminExpenses');
		this.options.canEdit = this.model.isNew() || (this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.canAddExpenses') && !this.options.isLocked);
	},
	renderData: function () {
		return {
			model: this.model,
			isAdmin: this.options.isAdmin,
			canEdit: this.options.canEdit
		};
	},
	afterRender: function () {
		if (this.options.canEdit) {
			new PJQ.Binder(this.$el, this.model, {
				watchElements: [
					'input',
					'textarea'
				]
			});
		}

		this.renderGroup();

		PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.expense-cost'), 2);

		this.paymentMethodSelectPicker = new PJQ.inputs.Selectpicker({
			el: $('.payment-method'),
			noneSelectedText: 'Select Payment Method',
			hideDisabled: false,
			isMultiple: false,
			defaultValue: this.model.get('paymentMethod'),
			onChange: _.bind(function () {
				this.model.set('paymentMethod', this.paymentMethodSelectPicker.getValue());
			}, this)
		});

		this.fileUploader = new PJQ.views.files.FileUploaderGrid({
			el: this.$('.expense-file-upload'),
			collection: this.model.attachments,
			canUpload: this.options.canEdit,
			// includeProjectAttachments: true,
			canDelete: this.options.isAdmin && this.options.canEdit,
			previewImageDimension: 150,
			sortDirection: 'asc',
			onDelete: _.bind(function (attachment, callback) {
				if (attachment.id > 0) {
					attachment.set('isDeleted', true);
				}
				else {
					attachment.destroy();
				}
				this.model.isDirty = true;
				callback();
			}, this)
		});
	},
	renderGroup: function () {
		if (this.model.group != null) {
			this.renderSubTemplate(false, this.options.subTemplates.groupBadge, this.$('.expense-group'),
				{
					models: [this.model.group],
					isReadOnly: this.options.canEdit
				});
		}
		else {
			this.$('.expense-group').html('<div class="text-muted font-weight-light fs-16 mt-2">Not Selected</div>');
		}
	},
	editGroup: function () {
		new PJQ.views.groups.SelectGroupsModal({
			selectorOptions: {
				isSingleChoice: true,
				selectedGroupIds: this.model.group ? this.model.group.id : null
			},
			onSave: _.bind(function (group) {
				this.model.set('group', group);
				this.renderGroup();
			}, this)
		});
	},
	deleteGroup: function () {
		this.model.set('group', null);
		this.renderGroup();
	},
	onSave: function () {
		if (this.fileUploader != null && this.fileUploader.isUploading()) {
			new PJQ.views.BaseModal({
				header: "Files Uploading",
				body: "You can't save while files are uploading"
			});
		}
		else {
			if (this.options.onSave) {
				this.options.onSave(this.model);
				this.removeModal();
			}
		}
	},
	close: function () {
		if (this.options.canEdit && this.model.hasChanged()) {
			new PJQ.views.modals.SaveDontSave({
				header: "Unsaved Changes",
				body: "Do you want to save changes?",
				onSave: _.bind(function () {
					this.onSave();
				}, this),
				onDontSave: _.bind(function () {
					this.onClose(this.model);
					this.removeModal();
				}, this)
			});
		}
		else {
			this.onClose(this.model);
			this.removeModal();
		}
	},
	onDelete: function () {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this expense?",
			onDelete: _.bind(function () {
				if (this.options.onDelete) {
					this.options.onDelete(this.model);
				}
				this.removeModal();
			}, this)
		});
	}
});

//Models
PJQ.models.dailyReports.InspectionLog = PJQ.models.BaseModel.extend({
	idAttribute: 'id',
	notifyName: 'Inspection Log',
	endpoint: function () {
		let params = null;
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'dailyReports',
				value: this.get('dailyReportId')
			},
			{
				endpoint: 'inspectionlogs',
				value: this.id
			}
		], params);
	},
	afterInit: function(){

	},
	parse: function (model) {
		if(model != null){
			if (model.contact) {
				this.contact = new PJQ.models.projectContacts.ProjectContact(model.contact);
			}
			else{
				this.contact = null;
			}

			this.attachments = new PJQ.collections.dailyReports.InspectionLogAttachments(model.attachments);
			this.attachments.on('update', _.bind(function(){
				this.isDirty = true;
			}, this));
		}
		return model;
	},
	beforeSave: function () {
		this.set('contact', this.contact);
		this.set('attachments', this.attachments.getChangedModels());
	}
});

PJQ.models.dailyReports.InspectionLogAttachment = PJQ.models.files.File.extend({
	idAttribute: 'attachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'inspectionlogs',
				value: this.get('logId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});

//Collections
PJQ.collections.dailyReports.InspectionLogs = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.InspectionLog
});

PJQ.collections.dailyReports.InspectionLogAttachments = PJQ.collections.dailyReports.Attachments.extend({
	model: PJQ.models.dailyReports.InspectionLogAttachment
});
PJQ.views.dailyReports.InspectionLogManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'inspection-log-management')
    },
    events: {
        'click .btn-add-log': 'addClicked',
        'click .btn-edit-log': 'editClicked',
        'click .btn-delete-log': 'deleteClicked'
    },
    beforeFirstRender: function () {
        this.options.isAdmin = PJQ.app.session.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.isAdminInspectionLogs');

        this.listenTo(this.collection, 'sync', _.bind(function () {
            this.dataTable.refresh();
        }, this));
    },
    beforeRender: function () {
        this.options.isLocked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT) && this.options.dailyReport.get('status') === 1;
        this.options.canEdit = this.options.project.hasPermission('dailyReports.canAddInspectionLogs') && !this.options.isLocked;
    },
    renderData: function () {
        return {
            project: this.options.project,
            canEdit: this.options.canEdit
        };
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: '.inspection-logs-data-table-container',
            data: this.collection.models,
            isHideSearch: true,
            rowId: "cid",
            order: [1, 'asc'],
            language: {
                zeroRecords: this.options.canEdit ? 'Click "Add Log" to create a new inspection log' : 'No inspection logs were added for this day'
            },
            onRowDoubleClick: _.bind(function (row) {
                this.editLog(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editLog(row.data());
                        }, this),
                        isShown: _.bind(function () {
                            return this.options.canEdit;
                        }, this)
                    },
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.editLog(row.data());
                        }, this),
                        isShown: _.bind(function () {
                            return !this.options.canEdit;
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: _.bind(function () {
                            return this.options.isAdmin && this.options.canEdit;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.deleteLog(row);
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "data": "attachments",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "50px",
                    "render": function (data) {
                        let attachmentCount = _.size(data.models);
                        return '<div><span class="fal fa-paperclip mr-1 ' + (attachmentCount > 0 ? 'text-success' : 'text-muted') + '"></span><span class="' + (attachmentCount > 0 ? 'text-dark' : 'text-muted') + '">' + attachmentCount.toString() + '</span></div>';
                    }
                },
                {
                    "data": "attributes.type",
                    "title": "Type",
                    "width": "150px",
                },
                {
                    "data": "",
                    "title": "Contact",
                    "searchable": false,
                    "render": function (data, type, row) {
                        let result = 'Not set';
                        if (row.contact != null) {
                            result = PJQ.helpers.contacts.getContactAnchor({
                                id: row.contact.id,
                                name: row.contact.get('companyName')
                            });
                        } else {
                            let name = row.get('name');
                            if (_.size(name) > 0) {
                                result = name;
                            }
                        }
                        return result;
                    }
                },
                {
                    "data": "attributes.time",
                    "title": "Time",
                    "searchable": false,
                    "width": "120px",
                    "render": function (data) {
                        if (data != null) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.TIME);
                        }
                        return 'Not Set';
                    }
                },
                {
                    "data": "attributes.status",
                    "title": "Status",
                    "width": "150px",
                    "render": function (data) {
                        let statusName = PJQ.constants.dailyReports.inspectionLogs.statusNames[data];
                        return statusName ? statusName : '';
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    resizable: false,
                    "width": "100px",
                    "render": _.bind(function () {
                        let buttons;
                        if (this.options.canEdit) {
                            buttons = '<button type="button" class="btn btn-info btn-edit-log ht-30p wd-35p mr-1 fs-14"><span class="fal fa-pencil"></span></button>';
                        } else {
                            buttons = '<button type="button" class="btn btn-info btn-edit-log ht-30p wd-35p mr-1 fs-14"><span class="fal fa-search"></span></button>';
                        }
                        if (this.options.isAdmin && this.options.canEdit) {
                            buttons += '<button type="button" class="btn btn-danger btn-delete-log ht-30p wd-35p fs-14"><span class="fal fa-trash"></span></button>';
                        }
                        return '<div class="text-align-right show-on-row-hover" style="width:80px;">' + buttons + '</div>';
                    }, this)
                }
            ]
        });
    },
    addClicked: function () {
        let newLog = new PJQ.models.dailyReports.InspectionLog({
            dailyReportId: this.options.dailyReport.id,
            time: new Date()
        });
        this.editLog(newLog);
    },
    editClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.editLog(row.data());
    },
    editLog: function (log) {
        new PJQ.views.dailyReports.EditInspectionLogModal({
            model: log,
            project: this.options.project,
            isLocked: this.options.isLocked,
            onSave: _.bind(function (log) {
                if (log.hasChanged() || log.isNew()) {
                    if (log.isNew()) {
                        this.collection.add(log);
                        this.dataTable.addRow(log);
                    }
                    log.save(null, {
                        notify: true
                    });
                    this.dataTable.refresh();
                }
            }, this),
            onClose: _.bind(function (log) {
                if (log.hasChanged()) {
                    log.fetch({
                        success: _.bind(function () {
                            this.dataTable.refresh();
                        }, this)
                    });
                }
            }, this),
            onDelete: _.bind(function (log) {
                if (log.id > 0) {
                    let row = this.dataTable.getRow(log.cid);
                    this.collection.remove(log);
                    log.destroy();
                    if (row != null) {
                        this.dataTable.removeRow(row);
                    }
                }
            }, this)
        });
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteLog(row);
    },
    deleteLog: function (row) {
        let log = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this inspection log?",
            onDelete: _.bind(function () {
                this.collection.remove(log);
                log.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    }
});

PJQ.views.dailyReports.EditInspectionLogModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'modal-edit-inspection-log'),
        maxWidth: 800
    },
    events: {
        'click .btn-reject': 'reject',
        'click .btn-approve': 'approve',
        'click .btn-save': 'onSave',
        'click .btn-close': 'close',
        'click .btn-delete': 'onDelete'
    },
    beforeModalCreated: function () {
        this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.isAdminInspectionLogs');
        this.options.canEdit = this.model.isNew() || (this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.canAddInspectionLogs') && !this.options.isLocked);
    },
    renderData: function () {
        return {
            model: this.model,
            isAdmin: this.options.isAdmin,
            canEdit: this.options.canEdit
        };
    },
    afterRender: function () {
        if (this.options.canEdit) {
            new PJQ.Binder(this.$el, this.model, {
                setDefaultValues: true,
                watchElements: [
                    'input',
                    'textarea'
                ]
            });

            this.renderStatus();

            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.log-contact'),
                context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                selectedContact: this.model.contact,
                isSingleChoice: true,
                isReadOnly: !this.options.canEdit,
                addButton: this.$('.btn-edit-contact'),
                onChange: _.bind(function (selectedContact) {
                    this.model.contact = selectedContact;
                    this.model.set('name', '');
                    this.model.isDirty = true;
                    this.renderContact();
                }, this)
            });
        }
        this.renderContact();

        new PJQ.inputs.Datepicker({
            el: this.$('.log-time'),
            isTimeOnly: true,
            datepickerOptions: {
                defaultDate: this.model.get('time')
            },
            onChange: _.bind(function (newTime) {
                let curTime = this.model.get('time');
                if (curTime == null || PJQ.helpers.dateHelpers.checkTimesDifferent(newTime, new Date(curTime))) {
                    this.model.set('time', newTime);
                }
            }, this)
        });

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.log-file-upload'),
            collection: this.model.attachments,
            canUpload: this.options.canEdit,
            // includeProjectAttachments: true,
            canDelete: this.options.isAdmin && this.options.canEdit,
            previewImageDimension: 150,
            sortDirection: 'asc',
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    attachment.destroy();
                }
                this.model.isDirty = true;
                callback();
            }, this)
        });
    },
    reject: function () {
        this.updateStatus(PJQ.constants.dailyReports.inspectionLogs.statuses.REJECTED);
    },
    approve: function () {
        this.updateStatus(PJQ.constants.dailyReports.inspectionLogs.statuses.APPROVED);
    },
    updateStatus: function (status) {
        this.model.set('status', status);
        this.renderStatus();
    },
    renderStatus: function () {
        let status = this.model.get('status');
        this.$('.log-status>button').each(function () {
            if ($(this).data('value') === status) {
                $(this).removeClass('inactive').addClass('font-weight-normal');
            } else {
                $(this).addClass('inactive').removeClass('font-weight-normal');
            }
        });
    },
    renderContact: function () {
        let $contactSelect = this.$('.log-contact'),
            $contactName = this.$('.log-name');
        if (this.model.contact != null) {
            $contactName.addClass('hidden');
            $contactSelect.removeClass('hidden');
        } else {
            $contactSelect.addClass('hidden');
            $contactName.removeClass('hidden');
        }
    },
    onSave: function () {
        if (this.fileUploader.isUploading()) {
            new PJQ.views.BaseModal({
                header: "Files Uploading",
                body: "You can't save while files are uploading"
            });
        } else {
            if (this.options.onSave) {
                this.options.onSave(this.model);
                this.removeModal();
            }
        }
    },
    close: function () {
        if (this.options.canEdit && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.onSave();
                }, this),
                onDontSave: _.bind(function () {
                    this.onClose(this.model);
                    this.removeModal();
                }, this)
            });
        } else {
            this.onClose(this.model);
            this.removeModal();
        }
    },
    onDelete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this inspection log?",
            onDelete: _.bind(function () {
                if (this.options.onDelete) {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});

//Models
PJQ.models.dailyReports.Note = PJQ.models.BaseModel.extend({
	idAttribute: 'noteId',
	notifyName: 'Note',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'dailyReports',
				value: this.get('dailyReportId')
			},
			{
				endpoint: 'notes',
				value: this.id
			}
		]);
	},
	parse: function (model) {
		model = model ? model : {};

		this.attachments = new PJQ.collections.dailyReports.NoteAttachments(model.attachments);
		this.attachments.on('update', _.bind(function () {
			this.isDirty = true;
		}, this));

		return model;
	},
	getCategoryName: function () {
		switch (this.get('category')) {
			case 0:
				return 'General Notes';
			case 1:
				return 'Safety Observations';
			case 2:
				return 'Quality Control Observations';
			case 3:
				return 'Materials';
			case 4:
				return 'Cost Impact';
			case 5:
				return 'Labor Request';
			default:
				return '';
		}
	},
	beforeSave: function () {
		this.set('attachments', this.attachments.getChangedModels());
	},
	restoreDefaultTheme: function () {

	}
});

PJQ.models.dailyReports.NoteAttachment = PJQ.models.files.File.extend({
	idAttribute: 'noteAttachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'notes',
				value: this.get('noteId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});

//Collections
PJQ.collections.dailyReports.Notes = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.Note
});

PJQ.collections.dailyReports.NoteAttachments = PJQ.collections.dailyReports.Attachments.extend({
	model: PJQ.models.dailyReports.NoteAttachment
});
PJQ.views.dailyReports.NoteManagement = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Note-Management')
	},
	events: {
		'click .add-note': 'addClicked',
		'click .edit-note': 'editClicked',
		'click .delete-note': 'deleteClicked'
	},
	beforeFirstRender: function () {
		this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.isAdminNotes');

		this.listenTo(this.collection, 'sync', _.bind(function () {
			this.dataTable.refresh();
		}, this));
	},
	beforeRender: function () {
		this.options.isLocked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT) && this.options.dailyReport.get('status') === 1;
		this.options.canEdit = this.options.project.hasPermission('dailyReports.canAddNotes') && !this.options.isLocked;
	},
	renderData: function () {
		return {
			project: this.options.project,
			canEdit: this.options.canEdit
		};
	},
	afterRender: function () {
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: '.notes-data-table-container',
			data: this.collection.models,
			isHideSearch: true,
			rowId: 'cid',
			order: [1, 'asc'],
			language: {
				zeroRecords: this.options.canEdit ? 'Click "Add Note" to create a new note' : 'No notes were added for this day'
			},
			onRowDoubleClick: _.bind(function (row) {
				if (!this.isLocked) {
					this.editNote(row.data());
				}
			}, this),
			contextMenuOptions: {
				actions: [
					{
						name: 'Edit',
						onClick: _.bind(function (row) {
							this.editNote(row.data());
						}, this),
						isShown: _.bind(function () {
							return this.options.canEdit;
						}, this)
					},
					{
						name: 'View',
						onClick: _.bind(function (row) {
							this.editNote(row.data());
						}, this),
						isShown: _.bind(function () {
							return !this.options.canEdit;
						}, this)
					},
					{
						name: 'Delete',
						isDanger: true,
						isShown: _.bind(function () {
							return this.options.isAdmin && this.options.canEdit;
						}, this),
						onClick: _.bind(function (row) {
							this.deleteNote(row);
						}, this)
					}
				]
			},
			columns: [
				{
					"data": "attachments",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": "50px",
					"render": function (data) {
						let attachmentCount = _.size(data.models);
						return '<div><span class="fal fa-paperclip mr-1 ' + (attachmentCount > 0 ? 'text-success' : 'text-muted') + '"></span><span class="' + (attachmentCount > 0 ? 'text-dark' : 'text-muted') + '">' + attachmentCount.toString() + '</span></div>';
					}
				},
				{
					"data": "attributes.category",
					"title": "Category",
					"width": "200px",
					"render": function (data, type, row) {
						return row.getCategoryName();
					}
				},
				{"data": "attributes.noteText", "title": "Description"},
				{
					"data": "",
					"title": "",
					"orderable": false,
					"searchable": false,
					resizable: false,
					"width": "100px",
					"render": _.bind(function () {
						let buttons;
						if (this.options.canEdit) {
							buttons = '<button type="button" class="btn btn-info edit-note ht-30p wd-35p mr-1 fs-14"><span class="fal fa-pencil"></span></button>';
						}
						else {
							buttons = '<button type="button" class="btn btn-info edit-note ht-30p wd-35p mr-1 fs-14"><span class="fal fa-search"></span></button>';
						}
						if (this.options.isAdmin && this.options.canEdit) {
							buttons += '<button type="button" class="btn btn-danger delete-note ht-30p wd-35p fs-14"><span class="fal fa-trash"></span></button>';
						}
						return '<div class="text-align-right show-on-row-hover" style="width:80px;">' + buttons + '</div>';
					}, this)
				}
			]
		});
	},
	addClicked: function () {
		let newNote = new PJQ.models.dailyReports.Note({
			dailyReportId: this.options.dailyReport.id,
			category: 0,
			noteText: ""
		});
		this.editNote(newNote);
	},
	editClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr')),
			note = row.data();
		this.editNote(note);
	},
	editNote: function (note) {
		new PJQ.views.dailyReports.EditNoteModal({
			model: note,
			project: this.options.project,
			isLocked: this.options.isLocked,
			onSave: _.bind(function (note) {
				if (note.hasChanged() || note.isNew()) {
					if (note.isNew()) {
						this.collection.add(note);
						this.dataTable.addRow(note);
					}
					note.save(null, {
						notify: true
					});
					this.dataTable.refresh();
				}
			}, this),
			onClose: _.bind(function (note) {
				if (note.hasChanged()) {
					note.fetch({
						success: _.bind(function () {
							this.dataTable.refresh();
						}, this)
					});
				}
			}, this),
			onDelete: _.bind(function (note) {
				if (note.id > 0) {
					let row = this.dataTable.getRow(note.cid);
					this.collection.remove(note);
					note.destroy();
					if (row != null) {
						this.dataTable.removeRow(row);
					}
				}
			}, this)
		});
	},
	deleteClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr'));
		this.deleteNote(row);
	},
	deleteNote: function (row) {
		let note = row.data();
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this note?",
			onDelete: _.bind(function () {
				this.collection.remove(note);
				note.destroy();
				this.dataTable.removeRow(row);
			}, this)
		});
	}
});

PJQ.views.dailyReports.EditNoteModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Modal-Edit-Note'),
		maxWidth: 800
	},
	events: {
		'click .note-save': 'onSave',
		'click .note-close': 'close',
		'click .note-delete': 'onDelete'
	},
	beforeModalCreated: function () {
		this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.isAdminNotes');
		this.options.canEdit = this.model.isNew() || (this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.canAddNotes') && !this.options.isLocked);
	},
	renderData: function () {
		return {
			model: this.model,
			isAdmin: this.options.isAdmin,
			canEdit: this.options.canEdit
		};
	},
	afterRender: function () {
		if (this.options.canEdit) {
			new PJQ.Binder(this.$el, this.model, {
				watchElements: [
					'input',
					'textarea'
				]
			});
		}

		new PJQ.inputs.Selectpicker({
			el: this.$('.note-category'),
			onChange: _.bind(function (value) {
				this.model.set('category', value);
			}, this),
			defaultValue: this.model.get('category')
		});

		this.fileUploader = new PJQ.views.files.FileUploaderGrid({
			el: this.$('.note-file-upload'),
			collection: this.model.attachments,
			canUpload: this.options.canEdit,
			// includeProjectAttachments: true,
			canDelete: this.options.isAdmin && this.options.canEdit,
			previewImageDimension: 150,
			sortDirection: 'asc',
			onDelete: _.bind(function (attachment, callback) {
				if (attachment.id > 0) {
					attachment.set('isDeleted', true);
				}
				else {
					attachment.destroy();
				}
				this.model.isDirty = true;
				callback();
			}, this)
		});
	},
	onSave: function () {
		if (this.fileUploader.isUploading()) {
			new PJQ.views.BaseModal({
				header: "Files Uploading",
				body: "You can't save while files are uploading"
			});
		}
		else {
			if (this.options.onSave) {
				this.options.onSave(this.model);
				this.removeModal();
			}
		}
	},
	close: function () {
		if (this.options.canEdit && this.model.hasChanged()) {
			new PJQ.views.modals.SaveDontSave({
				header: "Unsaved Changes",
				body: "Do you want to save changes?",
				onSave: _.bind(function () {
					this.onSave();
				}, this),
				onDontSave: _.bind(function () {
					this.onClose(this.model);
					this.removeModal();
				}, this)
			});
		}
		else {
			this.onClose(this.model);
			this.removeModal();
		}
	},
	onDelete: function () {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this note?",
			onDelete: _.bind(function () {
				if (this.options.onDelete) {
					this.options.onDelete(this.model);
				}
				this.removeModal();
			}, this)
		});
	}
});

//Models
PJQ.models.dailyReports.Settings = PJQ.models.BaseModel.extend({
	idAttribute: 'settingId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.get('project').id
			},
			{
				endpoint: 'dailyReports'
			},
			{
				endpoint: 'settings'
			}
		]);
	},
	parse: function(model){
		if(model){
			if(model.templates){
				this.templates = new PJQ.collections.dailyReports.SurveyTemplates(model.templates);
			}
			else{
				this.templates = new PJQ.collections.dailyReports.SurveyTemplates();
			}

			if(model.notificationSettings){
				this.notificationSettings = new PJQ.collections.dailyReports.NotificationSettingsPerUsers(model.notificationSettings);
			}
			else{
				this.notificationSettings = new PJQ.collections.dailyReports.NotificationSettingsPerUsers();
			}
		}
		else{
			this.templates = new PJQ.collections.dailyReports.SurveyTemplates(model.templates);
			this.notificationSettings = new PJQ.collections.dailyReports.NotificationSettingsPerUsers(model.notificationSettings);
		}
		return model;
	},
	beforeSave: function(){
		this.set('templates', _.map(this.templates.models, function(template){
			return {
				"surveyTemplateId": template.id
			};
		}));
	}
});

PJQ.models.dailyReports.NotificationSettingsPerUser = PJQ.models.BaseModel.extend({
	idAttribute: 'notificationSettingsUserId'
});


//Collections
PJQ.collections.dailyReports.NotificationSettingsPerUsers = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.NotificationSettingsPerUser,
	addUserForDay: function(id, day) {

		// find existing NotificationSettingPerUser
		let setting = null;
		_.each(this.models, _.bind(function(model) {
			if (model.get('userId') === id)
				setting = model;
		}, this));

		if (setting) {
			setting.set('workDays', setting.get('workDays') | day);
		}
		else {
			setting = new PJQ.models.dailyReports.NotificationSettingsPerUser();
			setting.set('userId', id);
			setting.set('projectId', PJQ.app.session.project.id);
			setting.set('workDays', day);

			this.models.push(setting);
		}
	},
	removeUserFromDay: function(id, day) {

		// find existing NotificationSettingPerUser
		let setting = null;
		_.each(this.models, _.bind(function(model) {
			if (model.get('userId') === id) {
				setting = model;
			}
		}, this));

		// remove this day from its bitmask
		setting.set('workDays', setting.get('workDays') & ~day);
	},
	getContactsForDay: function(day) {
		let contacts = [];
		_.each(this.models, _.bind(function(model) {
			if ((model.get('workDays') & day) === day) {
				let contact = new PJQ.models.BaseModel();
				contact.set('id', model.get('userId'));
				contact.set('companyName', model.get('companyName'));
				contact.set('contactName', model.get('contactName'));
				contacts.push(contact);
			}
		}, this));
		return contacts;
	}
});

PJQ.views.dailyReports.DailyReportSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Modal-Daily-Report-Settings'),
        subTemplates: {
            templateBadge: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Survey-Template-Badge')
        },
        maxWidth: 500
    },
    events: {
        'click .btn-report-day': 'reportDayClicked',
        'click .survey-template-edit': 'editTemplate',
        'click .survey-template-delete': 'removeTemplate',
        'click .is-disable-all-notifications': 'disableNotifications',
        'click .settings-save': 'onSave',
        'mouseup .input-adjust-image-size': 'adjustImageClicked'
    },
    afterModalCreated: function () {
        PJQ.app.session.project.fetchDailyReportSettings(_.bind(function (settings) {
            this.model = settings;
            PJQ.app.session.fetchDailyReportTemplates(_.bind(function (templates) {
                this.templates = templates;
                PJQ.app.session.fetchUsers(_.bind(function (contacts) {
                    this.contacts = contacts;
                    this.render()
                }, this));
            }, this));
        }, this));
    },
    renderData: function () {
        return {
            setDefaultValues: true,
            model: this.model,
            project: this.options.project
        };
    },
    afterRender: function () {
        if (this.model == null) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input'
            ]
        });

        this.workDayPicker = new PJQ.inputs.DayPicker({
            el: this.$('.work-days-outer'),
            defaultValue: this.model.get('workDays'),
            onChange: (value) => {
                this.model.set('workDays', value)
                this.notificationPerDayRefresh();
            }
        });
        this.notificationPerDayRefresh();

        let surveyName = this.options.project.preferences.getPref(PJQ.constants.preferenceTypes.DAILY_REPORT_SURVEY_NAME),
            attachmentsName = this.options.project.preferences.getPref(PJQ.constants.preferenceTypes.DAILY_REPORT_ATTACHMENTS_NAME);
        this.sort = [
            {
                attributes: {
                    name: "Weather",
                    sortNumber: this.model.get('weatherSort')
                }
            },
            {
                attributes: {
                    name: "Work Logs",
                    sortNumber: this.model.get('workLogSort')
                }
            },
            {
                attributes: {
                    name: "Notes",
                    sortNumber: this.model.get('noteSort')
                }
            },
            {
                attributes: {
                    name: "Deliveries",
                    sortNumber: this.model.get('deliverySort')
                }
            },
            {
                attributes: {
                    name: "Communications",
                    sortNumber: this.model.get('communicationSort')
                }
            },
            {
                attributes: {
                    name: "Inspections",
                    sortNumber: this.model.get('inspectionSort')
                }
            },
            {
                attributes: {
                    name: _.size(surveyName) > 0 ? surveyName : "Survey",
                    sortNumber: this.model.get('surveySort')
                }
            },
            {
                attributes: {
                    name: _.size(attachmentsName) > 0 ? attachmentsName : "Attachments",
                    sortNumber: this.model.get('attachmentSort')
                }
            }
        ];

        this.sortTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.export-sort-table'),
            isHideSearch: true,
            rowId: "cid",
            data: this.sort,
            order: [0, 'asc'],
            paging: false,
            columns: [
                {
                    "title": "Sort Order",
                    "data": "attributes.sortNumber",
                    "orderable": false,
                    "visible": false,
                    width: "80px",
                    "render": _.bind(function (data, type, row) {
                        let expenseSort = this.model.get('expenseSort');
                        if (data > expenseSort) {
                            return data - 1
                        } else {
                            return data
                        }
                    }, this)
                },
                {
                    "title": "Name",
                    "data": "attributes.name",
                    "orderable": false
                }
            ]
        });
        if (this.model != null) {
            this.reportTimePicker = new PJQ.inputs.Datepicker({
                el: this.$('.input-report-time'),
                isTimeOnly: true,
                datepickerOptions: {
                    defaultDate: new Date(this.model.get('time'))
                }
            });

            let projectStart = PJQ.app.session.project.get('startDate');
            this.projectStartDatePicker = new PJQ.inputs.Datepicker({
                el: this.$('.input-project-start'),
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.DATE.toUpperCase(),
                    defaultDate: projectStart != null ? PJQ.helpers.dateHelpers.parseDateString(projectStart, false) : null
                }
            });

            let projectEnd = PJQ.app.session.project.get('endDate');
            this.projectEndDatePicker = new PJQ.inputs.Datepicker({
                el: this.$('.input-project-end'),
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.DATE.toUpperCase(),
                    defaultDate: projectEnd != null ? PJQ.helpers.dateHelpers.parseDateString(projectEnd, false) : null
                }
            });

            new PJQ.Alert(this.$('.schedule-settings-alert'), {
                text: 'Any un-submitted reports on work days within the project start and finish dates will be automatically marked as missed after the due time.',
                cookie: PJQ.constants.cookies.NOTIFY_DAILY_REPORTS_PROJECT_START_END
            });

            this.notificationModeSelectPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.notification-mode'),
                hideDisabled: false,
                isMultiple: false,
                isRequired: true,
                isIntChoices: true,
                defaultValue: this.model.get('notificationMode'),
                onChange: _.bind(function () {
                    this.model.set('notificationMode', this.notificationModeSelectPicker.getValue());
                    this.notificationTypeChanged(this.notificationModeSelectPicker.getValue());
                }, this)
            });
            this.notificationTypeChanged(this.notificationModeSelectPicker.getValue());

            this.notificationSettingsPerDay = [];
            _.each(PJQ.constants.date.WEEKDAYNAMES, _.bind(function (day, index) {
                let ns = new PJQ.views.contacts.ContactsSelectInput({
                    el: this.$('.notification-settings-day-picker[data-day=' + day.bit + ']'),
                    context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                    selectedContact: this.model.notificationSettings.getContactsForDay(day.bit),
                    isSingleChoice: false,
                    emptyNotice: "No Project Contacts Selected",
                    onAdd: _.bind(function (contacts) {
                        _.each(contacts, _.bind(function (contact) {
                            this.model.notificationSettings.addUserForDay(contact.id, day.bit);
                        }, this));
                    }, this),
                    onDelete: _.bind(function (contact) {
                        this.model.notificationSettings.removeUserFromDay(contact.id, day.bit);
                    }, this)
                });

                this.notificationSettingsPerDay.push(ns);
            }, this));
            this.notificationPerDayRefresh();

            this.$('.submitted-email-list').val(this.model.get('submittedEmailList'));

            this.renderTemplatePicker();
            this.checkPixelValue();
        }
    },
    notificationPerDayRefresh: function () {
        let workdays = this.model.get('workDays');
        _.each(PJQ.constants.date.WEEKDAYNAMES, _.bind(function (day, index) {
            if ((workdays & day.bit) === day.bit) {
                this.$('.notification-settings-by-day[data-day=' + day.bit + ']').show();
            } else {
                this.$('.notification-settings-by-day[data-day=' + day.bit + ']').hide();
            }
        }, this));
    },
    notificationTypeChanged: function (value) {
        switch (value) {
            case PJQ.constants.dailyReports.notificationModes.DISABLED:
                this.$('.notification-settings-by-day-container, .submitted-email-list-container').hide();
                break;
            case PJQ.constants.dailyReports.notificationModes.PER_USER_DAY:
                this.$('.notification-settings-by-day-container').show();
                this.$('.submitted-email-list-container').show();
                break;
            default:
                this.$('.notification-settings-by-day-container').hide();
                this.$('.submitted-email-list-container').show();
        }
    },
    renderTemplatePicker: function () {
        let notPickedTemplates = _.filter(this.templates.models, _.bind(function (template) {
                return this.model.templates.get(template.id) == null;
            }, this)),
            $picker = $('<select>', {
                class: 'survey-template-picker'
            });

        $picker.append($('<option value="" disabled>Select value</option>'));
        let $newTemplateGroup = $('<optgroup>');
        $newTemplateGroup.append($('<option value="-1">New Template</option>'));
        $picker.append($newTemplateGroup);
        _.each(notPickedTemplates, function (template) {
            $picker.append($('<option>', {
                text: template.get('name'),
                value: template.id
            }));
        });
        this.$('.survey-template-picker-container').html($picker);

        this.templatePicker = new PJQ.inputs.Selectpicker({
            el: $picker,
            isIntChoices: true,
            hideDisabled: true,
            noneSelectedText: 'Select to add template',
            onChange: _.bind(function (templateId) {
                if (templateId === -1) {
                    this.addTemplate();
                } else {
                    let selectedTemplate = this.templates.get(templateId);
                    if (PJQ.app.session.project != null) {
                        selectedTemplate.set('projectId', PJQ.app.session.project.id)
                    }

                    this.model.templates.add(selectedTemplate);
                    this.renderTemplatePicker();
                }
            }, this)
        });

        let $selectedTemplates = this.$('.selected-templates');
        $selectedTemplates.empty();
        _.each(_.sortBy(this.model.templates.models, function (model) {
            return model.get('sortOrder');
        }), _.bind(function (template) {
            this.renderSubTemplate(true, this.options.subTemplates.templateBadge, $selectedTemplates, {
                model: template
            });
        }, this));
    },
    addTemplate: function () {
        let template = new PJQ.models.dailyReports.SurveyTemplate({
            name: "",
            isDefault: false
        });
        new PJQ.views.dailyReports.DailyReportTemplateManagementModal({
            model: template,
            contacts: this.contacts,
            onSave: _.bind(function () {
                this.templates.add(template);
                this.model.templates.add(template);
                this.renderTemplatePicker();
                this.options.onSave();
            }, this),
            onClose: _.bind(function () {
                this.renderTemplatePicker();
            }, this),
        });
    },
    editTemplate: function (e) {
        let template = this.model.templates.get($(e.currentTarget).closest('.survey-template-badge').data('id'));
        new PJQ.views.dailyReports.DailyReportTemplateManagementModal({
            model: template,
            onSave: this.options.onSave,
            contacts: this.contacts,
            onClose: _.bind(function () {
                this.renderTemplatePicker();
            }, this),
            onDelete: _.bind(function () {
                this.templates.remove(template.id);
                this.model.templates.remove(template.id);
                this.renderTemplatePicker();
                this.options.onSave();
            }, this)
        });
    },
    checkPixelValue: function () {
        if ((this.model.get('thumbDimenX') != null || this.model.get('thumbDimenY') != null)) {
            this.$('.input-adjust-image-size').prop('checked', true);
            this.$('.adjust-image-inputs').show("fast");
            this.$('.keep-aspect-ratio').show('fast');
        }
    },
    adjustImageClicked: function () {
        let isChecked = this.$('.input-adjust-image-size').prop('checked');
        !isChecked ? this.$('.adjust-image-inputs').show("fast") : this.$('.adjust-image-inputs').hide("fast");
        !isChecked ? this.$('.keep-aspect-ratio').show("fast") : this.$('.keep-aspect-ratio').hide("fast");
    },
    removeTemplate: function (e) {
        let templateId = $(e.currentTarget).closest('.survey-template-badge').data('id');
        this.model.templates.remove(templateId);
        this.renderTemplatePicker();
    },
    reportDayClicked: function (e) {
        let dayBtn = $(e.currentTarget);
        if (dayBtn.hasClass('selected')) {
            dayBtn.removeClass('btn-success font-weight-normal selected').addClass('btn-light text-medium');
        } else {
            dayBtn.removeClass('btn-light text-medium').addClass('btn-success font-weight-normal selected');
        }
        this.notificationPerDayRefresh();
    },
    onSave: function () {
        let rows = [];
        for (let i = 0; i < this.sortTable.dataTable.rows().data().length; i++) {
            rows.push(this.sortTable.dataTable.rows().data()[i])
        }
        _.each(rows, function (row) {
            switch (row.attributes.name) {
                case 'Weather':
                    this.model.set('weatherSort', row.attributes.sortNumber);
                    break;
                case 'Work Logs':
                    this.model.set('workLogSort', row.attributes.sortNumber);
                    break;
                case 'Notes':
                    this.model.set('noteSort', row.attributes.sortNumber);
                    break;
                case 'Deliveries':
                    this.model.set('deliverySort', row.attributes.sortNumber);
                    break;
                case 'Surveys':
                    this.model.set('surveySort', row.attributes.sortNumber);
                    break;
                case 'Attachments':
                    this.model.set('attachmentSort', row.attributes.sortNumber);
                    break;
            }
        }, this);

        let isExportWorkLogs = this.$('.input-export-work-logs').prop('checked'),
            isExportNotes = this.$('.input-export-notes').prop('checked'),
            isExportExpenses = this.$('.input-export-expenses').prop('checked'),
            isExportSurvey = this.$('.input-export-survey').prop('checked'),
            isExportDeliveries = this.$('.input-export-deliveries').prop('checked'),
            isExportCommunications = this.$('.input-export-communications').prop('checked'),
            isExportInspections = this.$('.input-export-inspections').prop('checked'),
            isExportAttachments = this.$('.input-export-attachments').prop('checked'),
            isExportWeather = this.$('.input-export-weather').prop('checked'),
            isHideUnansweredSurveyItems = this.$('.input-hide-unanswered-survey-questions').prop('checked'),
            isLockReportAfterSubmit = this.$('.input-submit-lock-report').prop('checked'),
            reportTime = this.reportTimePicker.getValue(),
            workDaysBit = this.workDayPicker.getValue(),
            submittedEmailList = this.$('.submitted-email-list').val(),
            notificationMode = this.notificationModeSelectPicker.getValue(),
            notificationSettings = this.model.notificationSettings.models,
            isShowAttachmentUploadedBy = this.$('.input-show-attachment-uploader').prop('checked'),
            thumbDimenX = this.$('.input-adjust-image-size').prop('checked') ? this.$('.input-thumb-x').val() : null,
            thumbDimenY = this.$('.input-adjust-image-size').prop('checked') ? this.$('.input-thumb-y').val() : null,
            isKeepThumbAspectRatio = this.$('.input-keep-aspect').prop('checked');

        if (isLockReportAfterSubmit) {
            PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT, isLockReportAfterSubmit)
        } else {
            PJQ.app.session.preferences.deletePref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT)
        }

        if (notificationMode === PJQ.constants.dailyReports.notificationModes.DISABLED) {
            submittedEmailList = '';
            // TODO: clear out any custom per-day notifications as well
        }

        if (_.size(this.model.templates) === 0) {
            this.templatePicker.showError("You must pick at least one template");
            return;
        }

        PJQ.helpers.inputHelpers.setInputError(this.$('.submitted-email-list'), true);
        if (submittedEmailList) {
            if (!PJQ.helpers.validators.validateEmail(submittedEmailList, true).success) {
                PJQ.helpers.inputHelpers.setInputError(this.$('.submitted-email-list'), false);
                return;
            }
        }

        //We have to be sure we save the project and the daily report settings before we callback to onSave
        //The onSave is likely waiting to get a new list of reports to refresh their statuses
        let loader = new PJQ.Loader(this.$('.modal-content')),
            startDate = this.projectStartDatePicker.getValue(),
            finishDate = this.projectEndDatePicker.getValue(),
            project = PJQ.app.session.project;
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'dates'
                }
            ]),
            data: {
                projectId: project.id,
                startDate: startDate,
                endDate: finishDate
            }
        }).put().done(_.bind(function () {
            PJQ.app.session.project.set({
                startDate: startDate,
                endDate: finishDate
            })
            this.model.save({
                workDays: workDaysBit,
                time: reportTime,
                isExportWorkLogs: isExportWorkLogs,
                isExportNotes: isExportNotes,
                isExportExpenses: isExportExpenses,
                isExportSurvey: isExportSurvey,
                isExportDeliveries: isExportDeliveries,
                isExportCommunications: isExportCommunications,
                isExportInspections: isExportInspections,
                isExportAttachments: isExportAttachments,
                isExportWeather: isExportWeather,
                isHideUnansweredSurveyItems: isHideUnansweredSurveyItems,
                isLockReportAfterSubmit: isLockReportAfterSubmit,
                isShowAttachmentUploadedBy: isShowAttachmentUploadedBy,
                thumbDimenX: thumbDimenX,
                thumbDimenY: thumbDimenY,
                isKeepThumbAspectRatio: isKeepThumbAspectRatio,
                submittedEmailList: submittedEmailList,
                notificationMode: notificationMode,
                notificationSettings: notificationSettings,
            }, {
                success: _.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave();
                    }
                    this.removeModal();
                }, this),
                error: function () {
                    loader.remove();
                    //todo: toast error
                }
            });
        }, this));
    }
});

PJQ.views.dailyReports.DailyReportTemplateManagementModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Modal-Daily-Report-Template-Management'),
        subTemplates: {
            item: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Template-Question-Edit')
        },
        maxWidth: 600,
        onSave: _.noop,
        onDelete: _.noop
    },
    events: {
        'click .btn-delete-template-question': 'removeQuestion',
        'click .btn-template-question-day': 'questionDayClicked',
        'click .btn-add-template-question': 'addQuestion',
        'click .template-delete': 'onDelete',
        'click .template-save': 'onSave',
        'click .template-close': 'onClose',
        'click .btn-survey-day': 'surveyDayClicked'
    },
    afterModalCreated: function () {
        this.model.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
        this.contacts = this.options.contacts;
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            contacts: this.contacts
        };
    },
    afterRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('.select-template-default'),
            defaultValue: this.model.get('isDefault'),
            onChange: _.bind(function (isDefault) {
                this.model.set('isDefault', isDefault === 'true')
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-template-contacts'),
            isMultiple: true,
            hideDisabled: false,
            isIntChoices: true,
            defaultValue: this.model.get('assignees') != null ? _.map(this.model.get('assignees'), function (assignee) {
                return assignee.id;
            }) : null,
            noneSelectedText: "All Project Contacts",
            onChange: _.bind(function (value) {
                let newAssignees;
                if (_.size(value) > 0) {
                    newAssignees = _.map(value, function (id) {
                        return {
                            id: id
                        };
                    });
                } else {
                    newAssignees = null;
                }
                this.model.set('assignees', newAssignees);
            }, this)
        });

        this.renderQuestions();
    },
    surveyDayClicked: function (e) {
        let dayBtn = $(e.currentTarget);
        if (dayBtn.hasClass('selected')) {
            dayBtn.removeClass('btn-success font-weight-normal selected').addClass('btn-light text-medium');
        } else {
            dayBtn.removeClass('btn-light text-medium').addClass('btn-success font-weight-normal selected');
        }

        let surveyDaysBit = 0;
        this.$('.btn-survey-day.selected').each(function () {
            surveyDaysBit += parseInt($(this).data('value'));
        });

        this.model.set('surveyDays', surveyDaysBit);
    },
    renderQuestions: function () {
        let $questions = this.$('.template-questions');
        $questions.empty();
        if (_.size(this.model.questions.models) > 0) {
            _.each(_.sortBy(_.filter(this.model.questions.models, function (model) {
                return !model.get('isDeleted');
            }), function (model) {
                return model.get('sortOrder');
            }), _.bind(function (question, index) {
                this.renderQuestion(question, index);
            }, this));
        } else {
            $questions.append($('<div>', {
                class: 'no-questions-text fs-16 font-weight-light text-muted text-align-center mt-2 mb-2',
                text: 'No questions added yet'
            }));
        }
    },
    renderQuestion: function (question, index) {
        let $questions = this.$('.template-questions');
        $questions.find('.no-questions-text').remove();
        this.renderSubTemplate(true, this.options.subTemplates.item, $questions, {
            model: question,
            index: index
        }, _.bind(function ($question) {
            new PJQ.inputs.Selectpicker({
                el: $question.find('.select-question-days'),
                isMultiple: true,
                noneSelectedText: 'No Days',
                isIntChoices: true,
                onChange: function (days) {
                    question.set('weekdays', _.reduce(days, function (total, day) {
                        return total + day;
                    }, 0));
                }
            });
        }, this))
    },
    questionDayClicked: function (e) {
        let dayBtn = $(e.currentTarget);
        if (dayBtn.hasClass('selected')) {
            dayBtn.removeClass('btn-success font-weight-normal selected').addClass('btn-light text-medium');
        } else {
            dayBtn.removeClass('btn-light text-medium').addClass('btn-success font-weight-normal selected');
        }
    },
    removeQuestion: function (e) {
        let $question = $(e.currentTarget).closest('.template-question'),
            cid = $(e.currentTarget).closest('.template-question').data('cid'),
            question = this.model.questions.get(cid);

        if (question.id > 0) {
            question.set('isDeleted', true);
        } else {
            this.model.questions.remove(cid);
        }
        $question.remove();
        _.each(this.model.questions.models, _.bind(function (question) {
            let $question = this.$('.template-question[data-cid="' + question.cid + '"]');
            question.set({
                question: $question.find('.input-template-question-question').val(),
                isAllowNote: $question.find('.input-template-question-allow-note').prop('checked'),
                isAllowYesNo: $question.find('.input-template-question-allow-yes-no').prop('checked'),
                isRequired: $question.find('.input-template-question-required').prop('checked')
            });
        }, this));
        this.render();
    },
    addQuestion: function () {
        let newQuestion = new PJQ.models.dailyReports.SurveyTemplateQuestion({
            surveyTemplateId: this.model.id,
            question: "",
            sortOrder: _.size(this.model.questions) + 1,
            isAllowNote: true,
            isAllowYesNo: true,
            weekdays: this.model.get('surveyDays')
        });
        this.model.questions.add(newQuestion);
        this.renderQuestion(newQuestion)
    },
    onDelete: function (e) {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this template?  This will also remove it from any projects it is on.",
            onDelete: _.bind(function () {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                this.model.destroy({
                    success: _.bind(function () {
                        this.options.onDelete();
                        this.removeModal();
                    }, this),
                    error: function () {
                        loader.remove();
                        //todo: toast error
                    }
                })
            }, this)
        });
    },
    onClose: function () {
        if (this.options.onClose) {
            this.options.onClose();
            this.removeModal();
        }
    },
    onSave: function () {
        let $templateName = this.$('.input-template-name'),
            templateName = $templateName.val();
        if (_.size(templateName) === 0) {
            PJQ.helpers.inputHelpers.setInputError($templateName, false);
            return;
        } else {
            PJQ.helpers.inputHelpers.setInputError($templateName, true);
        }

        let surveyDaysBit = 0;
        this.$('.btn-survey-day.selected').each(function () {
            surveyDaysBit += parseInt($(this).data('value'));
        });

        let loader = new PJQ.Loader(this.$('.modal-content'));
        _.each(this.model.questions.models, _.bind(function (question) {
            let $question = this.$('.template-question[data-cid="' + question.cid + '"]');
            question.set({
                question: $question.find('.input-template-question-question').val(),
                isAllowNote: $question.find('.input-template-question-allow-note').prop('checked'),
                isAllowYesNo: $question.find('.input-template-question-allow-yes-no').prop('checked'),
                isRequired: $question.find('.input-template-question-required').prop('checked')
            });
        }, this));
        this.model.save({
            projectId: PJQ.app.session.project != null ? PJQ.app.session.project.id : null,
            name: templateName,
            surveyDays: surveyDaysBit > 0 ? surveyDaysBit : null
        }, {
            success: _.bind(function () {
                this.options.onSave();
                this.removeModal();
            }, this),
            error: function () {
                loader.remove();
                //todo: toast error
            }
        });

    }
});

PJQ.views.dailyReports.DailyReportExportSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Modal-Daily-Report-Export-Settings'),
        maxWidth: 600,
        onSave: _.noop
    },
    events: {
        'click .settings-save': 'onSave',
        'mouseup .input-adjust-image-size': 'adjustImageClicked'
    },
    afterModalCreated: function () {
        PJQ.app.session.project.fetchDailyReportSettings(_.bind(function (settings) {
            this.model = settings;
            PJQ.app.session.fetchDailyReportTemplates(_.bind(function (templates) {
                this.templates = templates;
                this.render()
            }, this));
        }, this));
    },
    beforeRender: function () {
        this.renderData = {
            setDefaultValues: true,
            model: this.model
        };
    },
    afterRender: function () {
        if (this.model == null) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input'
            ]
        });

        let prefs = PJQ.app.session.project != null ? PJQ.app.session.project.preferences : PJQ.app.session.preferences,
            surveyName = prefs.getPref(PJQ.constants.preferenceTypes.DAILY_REPORT_SURVEY_NAME),
            attachmentsName = prefs.getPref(PJQ.constants.preferenceTypes.DAILY_REPORT_ATTACHMENTS_NAME);
        this.sort = [
            {
                attributes: {
                    name: "Weather",
                    sortNumber: this.model.get('weatherSort')
                }
            },
            {
                attributes: {
                    name: "Work Logs",
                    sortNumber: this.model.get('workLogSort')
                }
            },
            {
                attributes: {
                    name: "Notes",
                    sortNumber: this.model.get('noteSort')
                }
            },
            {
                attributes: {
                    name: "Deliveries",
                    sortNumber: this.model.get('deliverySort')
                }
            },
            {
                attributes: {
                    name: "Communications",
                    sortNumber: this.model.get('communicationSort')
                }
            },
            {
                attributes: {
                    name: "Inspections",
                    sortNumber: this.model.get('inspectionSort')
                }
            },
            {
                attributes: {
                    name: _.size(surveyName) > 0 ? surveyName : "Survey",
                    sortNumber: this.model.get('surveySort')
                }
            },
            {
                attributes: {
                    name: _.size(attachmentsName) > 0 ? attachmentsName : "Attachments",
                    sortNumber: this.model.get('attachmentSort')
                }
            }
        ];

        this.sortTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.export-sort-table'),
            isHideSearch: true,
            rowId: "cid",
            data: this.sort,
            order: [0, 'asc'],
            paging: false,
            columns: [
                {
                    "title": "Sort",
                    "data": "attributes.sortNumber",
                    "orderable": false,
                    "visible": false,
                    "render": _.bind(function (data) {
                        let expenseSort = this.model.get('expenseSort');
                        if (data > expenseSort) {
                            return data - 1
                        } else {
                            return data
                        }
                    }, this)
                },
                {
                    "title": "Name",
                    "data": "attributes.name",
                    "orderable": false
                }
            ]
        });
        this.checkPixelValue();
    },
    checkPixelValue: function () {
        if ((this.model.get('thumbDimenX') != null || this.model.get('thumbDimenY') != null || this.model.get('isKeepThumbAspectRatio') === true)) {
            $('.input-adjust-image-size').prop('checked', true);
            $('.adjust-image-inputs').show("fast");
            $('.keep-aspect-ratio').show('fast');
        }
    },
    adjustImageClicked: function () {
        let isChecked = $('.input-adjust-image-size').prop('checked');
        !isChecked ? $('.adjust-image-inputs').show("fast") : $('.adjust-image-inputs').hide("fast");
        !isChecked ? $('.keep-aspect-ratio').show("fast") : $('.keep-aspect-ratio').hide("fast")
    },
    onSave: function () {
        let rows = [];
        for (let i = 0; i < this.sortTable.dataTable.rows().data().length; i++) {
            rows.push(this.sortTable.dataTable.rows().data()[i])
        }
        _.each(rows, function (row) {
            switch (row.attributes.name) {
                case 'Weather':
                    this.model.set('weatherSort', row.attributes.sortNumber);
                    break;
                case 'Work Logs':
                    this.model.set('workLogSort', row.attributes.sortNumber);
                    break;
                case 'Notes':
                    this.model.set('noteSort', row.attributes.sortNumber);
                    break;
                case 'Deliveries':
                    this.model.set('deliverySort', row.attributes.sortNumber);
                    break;
                case 'Communications':
                    this.model.set('communicationSort', row.attributes.sortNumber);
                    break;
                case 'Inspections':
                    this.model.set('inspectionSort', row.attributes.sortNumber);
                    break;
                case 'Surveys':
                    this.model.set('surveySort', row.attributes.sortNumber);
                    break;
                case 'Attachments':
                    this.model.set('attachmentSort', row.attributes.sortNumber);
                    break;
            }
        }, this);
        let isExportWorkLogs = this.$('.input-export-work-logs').prop('checked'),
            isExportNotes = this.$('.input-export-notes').prop('checked'),
            isExportExpenses = this.$('.input-export-expenses').prop('checked'),
            isExportSurvey = this.$('.input-export-survey').prop('checked'),
            isExportDeliveries = this.$('.input-export-deliveries').prop('checked'),
            isExportCommunications = this.$('.input-export-communications').prop('checked'),
            isExportInspections = this.$('.input-export-inspections').prop('checked'),
            isExportAttachments = this.$('.input-export-attachments').prop('checked'),
            isExportWeather = this.$('.input-export-weather').prop('checked'),
            isHideUnansweredSurveyItems = this.$('.input-hide-unanswered-survey-questions').prop('checked'),
            thumbDimenX = this.$('.input-adjust-image-size').prop('checked') ? this.$('.input-thumb-x').val() : null,
            thumbDimenY = this.$('.input-adjust-image-size').prop('checked') ? this.$('.input-thumb-y').val() : null,
            isShowAttachmentUploadedBy = this.$('.input-show-attachment-uploader').prop('checked'),
            isKeepThumbAspectRatio = this.$('.input-keep-aspect').prop('checked');

        this.model.set({
            isExportWorkLogs: isExportWorkLogs,
            isExportNotes: isExportNotes,
            isExportExpenses: isExportExpenses,
            isExportSurvey: isExportSurvey,
            isExportDeliveries: isExportDeliveries,
            isExportCommunications: isExportCommunications,
            isExportInspections: isExportInspections,
            isExportAttachments: isExportAttachments,
            isExportWeather: isExportWeather,
            isHideUnansweredSurveyItems: isHideUnansweredSurveyItems,
            thumbDimenX: thumbDimenX,
            thumbDimenY: thumbDimenY,
            isShowAttachmentUploadedBy: isShowAttachmentUploadedBy,
            isKeepThumbAspectRatio: isKeepThumbAspectRatio
        });

        this.options.onSave(this.model);
        this.removeModal();
    }
});

//Models
PJQ.models.dailyReports.SurveyTemplateQuestion = PJQ.models.BaseModel.extend({
	idAttribute: 'surveyQuestionId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'dailyReports'
			},
			{
				endpoint: 'template',
				value: this.get('surveyTemplateId')
			},
			{
				endpoint: 'question',
				value: this.id
			}
		]);
	}
});

PJQ.models.dailyReports.SurveyTemplateUser = PJQ.models.BaseModel.extend({
	idAttribute: 'templateUserId'
});

PJQ.models.dailyReports.SurveyItem = PJQ.models.dailyReports.SurveyTemplateQuestion.extend({
	idAttribute: 'surveyAnswerId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'dailyReports',
				value: this.get('dailyReportId')
			},
			{
				endpoint: 'survey',
				value: this.id
			}
		]);
	},
	parse: function (model) {
		model = model ? model : {};

		// ensure that answer is never an empty string, only null or a value
		if(model.answer != null && _.size(model.answer) === 0){
			model.answer = null;
		}

		this.attachments = new PJQ.collections.dailyReports.SurveyAttachments(model.attachments);

		return model;
	},
	isValid: function () {
		return !this.get('isRequired') || _.size(this.get('answer')) > 0 || _.size(this.get('answerNote')) > 0
			|| _.size(this.attachments.models) > 0;
	}
});

PJQ.models.dailyReports.SurveyAttachment = PJQ.models.files.File.extend({
	idAttribute: 'attachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'survey',
				value: this.get('surveyAnswerId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});

PJQ.models.dailyReports.SurveyTemplate = PJQ.models.BaseModel.extend({
	idAttribute: 'surveyTemplateId',
	endpoint: function (opts, method) {
		if (this.get('projectId') > 0 && !this.isNew() && method.toLowerCase() === "get") {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.get('projectId')
				},
				{
					endpoint: 'dailyReports',
				},
				{
					endpoint: 'templates',
					value: this.id
				}
			]);
		}
		else {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'dailyReports',
				},
				{
					endpoint: 'templates',
					value: this.id
				}
			]);
		}
	},
	parse: function (model) {
		model = model ? model : {};

		this.questions = new PJQ.collections.dailyReports.SurveyTemplateQuestions(model.questions);
		this.users = new PJQ.collections.dailyReports.SurveyUsers(model.users);

		return model;
	},
	beforeSave: function () {
		this.set('questions', this.questions.models);
		this.set('users', this.users.models);
	},
});


//Collections
PJQ.collections.dailyReports.SurveyAttachments = PJQ.collections.dailyReports.Attachments.extend({
	model: PJQ.models.dailyReports.SurveyAttachment
});

PJQ.collections.dailyReports.SurveyTemplates = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.SurveyTemplate,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'dailyReports'
			},
			{
				endpoint: 'templates'
			}
		]);
	}
});

PJQ.collections.dailyReports.SurveyTemplateQuestions = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.SurveyItem,
	getCompletedItems: function () {
		return _.filter(this.models, function (surveyItem) {
			if (surveyItem.get('fieldType').toLowerCase() === 'bool') {
				return _.size(surveyItem.get('answer')) > 0 || _.size(surveyItem.get('answerNote')) > 0 || _.size(surveyItem.attachments) > 0;
			}
			return false;
		})
	}
});

PJQ.collections.dailyReports.SurveyItems = PJQ.collections.dailyReports.SurveyTemplateQuestions.extend({
	model: PJQ.models.dailyReports.SurveyItem,
	getCompletedItems: function () {
		return _.filter(this.models, function (surveyItem) {
			if (surveyItem.get('fieldType').toLowerCase() === 'bool') {
				return _.size(surveyItem.get('answer')) > 0 || _.size(surveyItem.get('answerNote')) > 0 || _.size(surveyItem.attachments) > 0;
			}
			return false;
		})
	}
});

PJQ.collections.dailyReports.SurveyUsers = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.SurveyTemplateUser,
});

PJQ.views.dailyReports.Survey = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Survey')
    },
    afterRender: function () {
        this.itemViews = [];
        _.each(this.model.surveyItems.models, function (surveyItem, index) {
            let itemEl = $('<div>');
            this.$('.survey-items').append(itemEl);

            let iv = new PJQ.views.dailyReports.SurveyItem({
                el: itemEl,
                model: surveyItem,
                dailyReport: this.model,
                project: this.options.project,
                index: index,
                isLocked: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT) && this.model.get('status') === 1
            });
            this.itemViews.push(iv);
        }, this);
    },
    validate: function () {
        let isValid = true;
        _.each(this.itemViews, function (itemView) {
            isValid = itemView.validate() && isValid;
        }, this);
        return isValid;
    }
});

PJQ.views.dailyReports.SurveyItem = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Survey-Item')
    },
    events: {
        'click .survey-answer>button': 'answerChanged',
        'keyup .survey-answer-note': 'answerNoteChanged'
    },
    beforeFirstRender: function () {
        this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.isAdminSurvey');
        this.options.canEdit = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.canAnswerSurvey') && !this.options.isLocked;
    },
    renderData: function () {
        return {
            model: this.model,
            index: this.options.index,
            canEdit: this.options.canEdit,
            isValidate: this.options.isValidate
        };
    },
    afterRender: function () {
        this.renderAnswerButtonGroup();

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.survey-item-attachment-file-upload'),
            canUpload: this.options.canEdit,
            // includeProjectAttachments: true,
            canDelete: this.options.isAdmin && this.options.canEdit,
            sortDirection: 'asc',
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'survey',
                    value: this.model.id
                },
                {
                    endpoint: 'attachments'
                }
            ]),
            onSuccess: _.bind(function (file) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'survey',
                            value: this.model.id
                        },
                        {
                            endpoint: 'attachments'
                        }
                    ]),
                    data: file,
                }).put().done(_.bind(function (file) {
                }, this)).fail(onScriptError);
            }, this),
            collection: this.model.attachments
        });
    },
    answerChanged: function (e) {
        let selectedValue = $(e.currentTarget).data('value');
        this.model.set('answer', selectedValue.toString());
        this.renderAnswerButtonGroup();
        this.model.queueSave();
    },
    answerNoteChanged: function () {
        this.model.set('answerNote', this.$('.survey-answer-note').val());
        this.model.queueSave();
    },
    renderAnswerButtonGroup: function () {
        let self = this,
            answer = self.model.get('answer');
        if (answer != null) {
            answer = answer.toString();
        }

        this.$('.survey-answer>button').each(function () {
            if ($(this).data('value').toString() === answer) {
                $(this).removeClass('inactive').addClass('font-weight-normal');
            } else {
                $(this).addClass('inactive').removeClass('font-weight-normal');
            }
        });
    },
    validate: function () {
        this.options.isValidate = true;
        this.render();
        return this.model.isValid();
    }
});

//Models
PJQ.models.dailyReports.WorkLog = PJQ.models.BaseModel.extend({
	idAttribute: 'workLogId',
	notifyName: 'Work Log',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'dailyReports',
                value: this.get('dailyReportId')
            },
            {
                endpoint: 'workLogs',
                value: this.id
            }
        ]);
	},
	parse: function (model) {
		model = model ? model : {};

		if (model.workBy) {
			this.workBy = new PJQ.models.projectContacts.ProjectContact(model.workBy);
		}
		else{
			this.workBy = null;
		}

		this.groups = new PJQ.collections.groups.Groups(model.groups);

		this.workItems = new PJQ.collections.dailyReports.WorkLogWorkItems(model.workItems);

		this.attachments = new PJQ.collections.dailyReports.WorkLogAttachments(model.attachments);
		this.attachments.on('update', _.bind(function(){
			this.isDirty = true;
		}, this));

		return model;
	},
	beforeSave: function () {
		this.set('workBy', this.workBy);
		this.set('groups', this.groups.toJSON());
		this.set('workItems', this.workItems.toJSON());
		this.set('attachments', this.attachments.toJSON());
	}
});

PJQ.models.dailyReports.WorkLogWorkItem = PJQ.models.BaseModel.extend({
	idAttribute: 'id',
	notifyName: 'Work Item'
});

PJQ.models.dailyReports.WorkLogAttachment = PJQ.models.dailyReports.Attachment.extend({
	idAttribute: 'workLogAttachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'workLogs',
				value: this.get('workLogId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});


//Collections
PJQ.collections.dailyReports.WorkLogs = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.dailyReports.WorkLog
});

PJQ.collections.dailyReports.WorkLogWorkItems = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.WorkLogWorkItem
});

PJQ.collections.dailyReports.WorkLogAttachments = PJQ.collections.dailyReports.Attachments.extend({
	model: PJQ.models.dailyReports.WorkLogAttachment
});
PJQ.views.dailyReports.WorkLogManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Work-Log-Management'),
        filters: {}
    },
    events: {
        'click .btn-filter': 'filterClicked',
        'click .btn-clear-filter': 'clearFilters',
        'click .btn-add-work-log': 'addClicked',
        'click .btn-carry-work-logs-all': 'carryOverWorkLogsAll',
        'click .btn-carry-work-logs-last': 'carryOverWorkLogsLast',
        'click .btn-delete-all-work-logs': 'deleteAllWorkLogs',
        'click .edit-work-log': 'editClicked',
        'click .delete-work-log': 'deleteClicked'
    },
    beforeFirstRender: function () {
        this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.isAdminWorkLogs');

        let fnRender = _.bind(function () {
            this.listenTo(this.collection, 'sync update reset', _.bind(function () {
                this.dataTable.refresh();
            }, this));

            this.render();
        }, this)

        if (this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
            this.options.project.fetchLocations(_.bind(function (locations) {
                this.locations = locations;
                fnRender();
            }, this));
        } else {
            fnRender();
        }
    },
    beforeRender: function () {
        this.options.isLocked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT) && this.options.dailyReport.get('status') === 1;
        this.options.canEdit = this.options.project.hasPermission('dailyReports.canAddWorkLogs') && !this.options.isLocked;
    },
    renderData: function () {
        return {
            project: this.options.project,
            canEdit: this.options.canEdit
        };
    },
    afterRender: function () {
        let enableLocations = this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS);
        if (this.locations == null && enableLocations) {
            return;
        }

        if (enableLocations) {
            this.locationFilterPicker = new PJQ.inputs.ProjectLocationPicker({
                el: this.$('.filter-location'),
                project: this.options.project,
                isMultiple: true,
                onChange: _.bind(function (value) {
                    this.options.filters.locations = value;
                    this.filterData();
                }, this)
            });
        }

        this.renderDataTable();
    },
    filterClicked: function () {
        this.$('.btn-filter').hide();
        this.$('.filter-outer').show();
    },
    clearFilters: function () {
        this.locationFilterPicker.setValue(null);
        this.$('.btn-filter').show();
        this.$('.filter-outer').hide();
        this.options.filters = {};
        this.filterData();
    },
    filterData: function () {
        let data;
        if (_.size(this.options.filters.locations) > 0) {
            data = _.filter(this.collection.models, function (model) {
                return _.contains(this.options.filters.locations, model.get('locationId'));
            }, this);
        } else {
            data = this.collection.models;
        }
        this.dataTable.resetData(data);
    },
    renderDataTable: function () {
        let columns = [
            {
                "data": "attachments",
                "title": "",
                "orderable": false,
                "searchable": false,
                "width": "50px",
                "render": function (data) {
                    let attachmentCount = _.size(data.models);
                    return '<div style="min-width:40px;"><span class="fal fa-paperclip mr-1 ' + (attachmentCount > 0 ? 'text-success' : 'text-muted') + '"></span><span class="' + (attachmentCount > 0 ? 'text-dark' : 'text-muted') + '">' + attachmentCount.toString() + '</span></div>';
                }
            },
            {
                "data": "attributes",
                "title": "Name",
                "searchable": false,
                "width": "200px",
                "render": function (data, type, row) {
                    if (row.workBy != null) {
                        return row.workBy.get('contactName') + ' (' + row.workBy.get('companyName') + ')';
                    }
                    return row.get('name');
                }
            },
            {"data": "attributes.quantity", "title": "Quantity", "searchable": false, "width": "120px"},
            {
                "data": "attributes.hours",
                "title": "Hours",
                "searchable": false,
                "width": "120px",
                "render": function (data) {
                    return data > 0 ? data / 100 : 0;
                }
            },
            {
                "data": "attributes.groups",
                "title": "Trades",
                "orderable": true,
                "render": _.bind(function (data, type, row) {
                    return _.map(_.sortBy(row.groups.models, function (group) {
                        return group.get('sortOrder');
                    }), function (group) {
                        return group.get('groupName');
                    }).join(', ');
                }, this)
            }
        ];

        if (!this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
            columns.push({"data": "attributes.description", "title": "Description"});
        } else {
            columns.push({
                "data": "attributes.locationId",
                "title": "Location",
                "orderable": true,
                "width": "200px",
                "render": _.bind(function (data, type, row) {
                    let location = this.locations.get(data);
                    return location ? this.locations.getFullName(location) : '';
                }, this)
            });
        }

        columns.push({
            "data": "",
            "title": "",
            "orderable": false,
            "searchable": false,
            resizable: false,
            "width": "100px",
            "render": _.bind(function () {
                let buttons;
                if (this.options.canEdit) {
                    buttons = '<button type="button" class="btn btn-info edit-work-log ht-30p wd-35p mr-1 fs-14"><span class="fal fa-pencil"></span></button>';
                } else {
                    buttons = '<button type="button" class="btn btn-info edit-work-log ht-30p wd-35p mr-1 fs-14"><span class="fal fa-search"></span></button>';
                }
                if (this.options.isAdmin && this.options.canEdit) {
                    buttons += '<button type="button" class="btn btn-danger delete-work-log ht-30p wd-35p fs-14"><span class="fal fa-trash"></span></button>';
                }
                return '<div class="text-align-right show-on-row-hover" style="width:80px;">' + buttons + '</div>';
            }, this)
        });

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: '.work-logs-data-table-container',
            data: this.collection.models,
            isHideSearch: true,
            rowId: 'cid',
            order: [1, 'asc'],
            language: {
                zeroRecords: this.options.canEdit ? 'Click "Add Work Log" to create a new work log' : 'No work logs were added for this day'
            },
            onRowDoubleClick: _.bind(function (row) {
                this.editWorkLog(row.data());
            }, this),
            contextMenuOptions: this.isLocked ? null : {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editWorkLog(row.data());
                        }, this),
                        isShown: _.bind(function () {
                            return this.options.canEdit;
                        }, this)
                    },
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.editWorkLog(row.data());
                        }, this),
                        isShown: _.bind(function () {
                            return !this.options.canEdit;
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: _.bind(function () {
                            return this.options.isAdmin && this.options.canEdit;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.deleteWorkLog(row);
                        }, this)
                    }
                ]
            },
            columns: columns
        });
    },
    addClicked: function () {
        let newWorkLog = new PJQ.models.dailyReports.WorkLog({
            dailyReportId: this.options.dailyReport.id,
            name: "",
            quantity: null,
            hours: null,
            description: ""
        });
        this.editWorkLog(newWorkLog);
    },
    carryOverWorkLogsAll: function () {
        new PJQ.views.BaseModal({
            header: 'Confirm Comment',
            body: '<div class="text-dark">Are you sure you want to carry over work logs from all previous days?</div>',
            okButtonText: 'Carry Over',
            onOk: _.bind(function () {
                new PJQ.ajax.Request({
                    endpoint: this.options.dailyReport.endpoint() + '/workLogs/copy'
                }).get().done(_.bind(function (workLogs) {
                    let carriedWorkLogs = new PJQ.collections.dailyReports.WorkLogs(workLogs);
                    this.dataTable.addRow(carriedWorkLogs.models);
                    this.collection.reset(carriedWorkLogs.models);
                }, this)).fail(_.bind(function (xhr, err, result) {
                    //todo: error
                }, this));
            }, this),
            isShowCancelButton: true,
            cancelButtonText: "Cancel"
        });
    },
    carryOverWorkLogsLast: function () {
        new PJQ.views.BaseModal({
            header: 'Confirm Comment',
            body: '<div class="text-dark">Are you sure you want to carry over work logs from the last work day?</div>',
            okButtonText: 'Carry Over',
            onOk: _.bind(function () {
                new PJQ.ajax.Request({
                    endpoint: this.options.dailyReport.endpoint() + '/workLogs/copy?lastWorkDay=true'
                }).get().done(_.bind(function (workLogs) {
                    let carriedWorkLogs = new PJQ.collections.dailyReports.WorkLogs(workLogs);
                    this.dataTable.addRow(carriedWorkLogs.models);
                    this.collection.reset(carriedWorkLogs.models);
                }, this)).fail(_.bind(function (xhr, err, result) {
                    //todo: error
                }, this));
            }, this),
            isShowCancelButton: true,
            cancelButtonText: "Cancel"
        });
    },
    deleteAllWorkLogs: function () {
        new PJQ.views.BaseModal({
            header: 'Confirm Deletion',
            body: '<div class="text-dark">Are you sure you want to delete all work logs for this day?</div>',
            okButtonText: 'Delete Work Logs',
            onOk: _.bind(function () {
                new PJQ.ajax.Request({
                    endpoint: this.options.dailyReport.endpoint() + '/workLogs'
                }).delete().done(_.bind(function () {
                    this.collection.reset(null);
                    this.render();
                }, this)).fail(_.bind(function (xhr, err, result) {
                    //todo: error
                }, this));
            }, this),
            isShowCancelButton: true,
            cancelButtonText: "Cancel"
        });
    },
    editClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            workLog = row.data();
        this.editWorkLog(workLog);
    },
    editWorkLog: function (workLog) {
        let isNew = workLog == null || workLog.isNew();
        new PJQ.views.dailyReports.EditWorkLogModal({
            model: workLog,
            project: this.options.project,
            isLocked: this.options.isLocked,
            onSave: _.bind(function (workLog) {
                if (isNew) {
                    this.dataTable.addRow(workLog);
                    this.collection.add(workLog);
                }
                this.dataTable.refresh();
            }, this),
            onClose: _.bind(function (workLog) {
                if (workLog.hasChanged()) {
                    workLog.fetch({
                        success: _.bind(function () {
                            this.dataTable.refresh();
                        }, this)
                    });
                }
            }, this),
            onDelete: _.bind(function (workLog) {
                if (workLog.id > 0) {
                    let row = this.dataTable.getRow(workLog.cid);
                    if (row != null) {
                        this.dataTable.removeRow(row);
                    }
                    this.collection.remove(workLog);
                    workLog.destroy();
                }
            }, this)
        });
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteWorkLog(row);
    },
    deleteWorkLog: function (row) {
        let workLog = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this work log?",
            onDelete: _.bind(function () {
                this.collection.remove(workLog);
                workLog.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    }
});

PJQ.views.dailyReports.EditWorkLogModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Modal-Edit-Work-Log'),
        subTemplates: {
            workItem: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'work-log-work-item'),
        },
        maxWidth: 800
    },
    events: {
        'click .work-log-save': 'save',
        'click .work-log-close': 'close',
        'keydown .input-numeric': 'numbersOnly',
        'click .work-log-delete': 'onDelete',
        'click .btn-add-work-item': 'addWorkItem',
        'click .btn-delete-work-item': 'deleteWorkItem',
        'change .progress-slider': 'progressChanged',
    },
    beforeModalCreated: function () {
        this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.isAdminWorkLogs');
        this.options.canEdit = this.model.isNew() || (this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.canAddWorkLogs') && !this.options.isLocked);

        this.options.enableWorkItems = this.options.project.preferences.getPref(PJQ.constants.preferenceTypes.ENABLE_WORK_LOG_WORK_ITEMS);
        this.options.enableProgress = this.options.project.preferences.getPref(PJQ.constants.preferenceTypes.ENABLE_WORK_LOG_PROGRESS);
        this.options.workItemsLabel = this.options.project.preferences.getPref(PJQ.constants.preferenceTypes.WORK_LOG_WORK_ITEM_LABEL);
        this.options.workItemsSubText = this.options.project.preferences.getPref(PJQ.constants.preferenceTypes.WORK_LOG_WORK_ITEM_SUB_TEXT);
    },
    renderData: function () {
        return {
            model: this.model,
            options: this.options,
            enableProgress: this.options.enableProgress,
            project: this.options.project,
            isAdmin: this.options.isAdmin,
            canEdit: this.options.canEdit
        };
    },
    afterRender: function () {
        this.model.on('change', function () {
            this.calculateTotal();
        }, this);
        this.calculateTotal();

        new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.work-by'),
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            selectedContact: this.model.workBy,
            isReadOnly: !this.options.canEdit,
            isSingleChoice: true,
            addButton: this.$('.btn-edit-work-by'),
            onChange: _.bind(function (selectedContact) {
                this.model.workBy = selectedContact;
                this.model.set('name');
                this.model.isDirty = true;
                this.renderWorkBy();
            }, this)
        });
        this.renderWorkBy();

        if (this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_LOCATIONS)) {
            new PJQ.inputs.ProjectLocationPicker({
                el: this.$('.select-location'),
                project: this.options.project,
                onChange: _.bind(function (value) {
                    this.model.set('locationId', value);
                }, this),
                defaultValue: this.model.get('locationId')
            });
        }

        new PJQ.views.groups.GroupsSelectInput({
            el: this.$('.work-log-groups'),
            isShowAddButton: false,
            addButton: this.$('.btn-edit-groups'),
            selectedGroups: this.model.groups.models,
            isReadOnly: !this.options.canEdit,
            onAfterSave: _.bind(function (selectedGroups) {
                this.model.groups.reset(selectedGroups);
                this.model.isDirty = true;
            }, this)
        });

        if (this.options.canEdit) {
            new PJQ.Binder(this.$el, this.model, {
                watchElements: [
                    'input',
                    'textarea'
                ]
            });
        }

        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.work-log-hours'), 2);

        this.renderWorkItems();

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.work-log-file-upload'),
            collection: this.model.attachments,
            canUpload: this.options.canEdit,
            // includeProjectAttachments: true,
            canDelete: this.options.isAdmin && this.options.canEdit,
            previewImageDimension: 150,
            sortDirection: 'asc',
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    attachment.destroy();
                }
                this.model.isDirty = true;
                callback();
            }, this)
        });

        if (this.options.enableProgress) {
            this.renderProgress();
        }
    },
    renderProgress: function () {
        this.progressSlider = this.$('.progress-slider').bootstrapSlider({
            handle: 'square'
        });

        this.$('.progress-slider').append($('<div>', {
            class: 'font-weight-light fs-14 bg-' + this.options.colorClass + ' text-' + (this.options.colorClass === 'warning' ? 'dark' : 'light')
        }).text(this.model.get('progress') + '%'));

        this.progressChanged();
    },
    progressChanged: function () {
        let percent = this.progressSlider.data('bootstrapSlider').getValue(),
            $slider = this.$('.slider-selection'),
            $text = this.$('.progress-percent');
        $text.text(percent + '%');
        $text.removeClass('text-danger').removeClass('text-warning').removeClass('text-success');
        $slider.removeClass('slider-bg-danger bg-danger').removeClass('slider-bg-warning bg-warning')
            .removeClass('slider-bg-success bg-success');
        if (percent < 60) {
            $text.addClass('text-danger');
            $slider.addClass('slider-bg-danger bg-danger');
        } else if (percent >= 60 && percent < 100) {
            $text.addClass('text-warning');
            $slider.addClass('slider-bg-warning bg-warning');
        } else {
            $text.addClass('text-success');
            $slider.addClass('slider-bg-success bg-success');
        }
        if (this.model.get('progress') !== percent) {
            this.model.set('progress', percent);
        }
    },
    addWorkItem: function () {
        let workItem = new PJQ.models.dailyReports.WorkLogWorkItem({
            workLogId: this.model.id
        });
        this.model.workItems.add(workItem);
        this.renderWorkItem(workItem);
    },
    deleteWorkItem: function (e) {
        let $workItem = $(e.currentTarget).closest('.work-item'),
            workItemId = $workItem.data('cid'),
            workItem = this.model.workItems.get(workItemId);
        if (workItem != null) {
            if (workItem.id > 0) {
                workItem.set('delete', true);
            } else {
                this.model.workItems.remove(workItem);
            }
            $workItem.remove();
            this.model.isDirty = true;
        }
    },
    renderWorkItems: function () {
        _.each(this.model.workItems.models, (workItem) => {
            if (workItem.get('delete')) {
                return;
            }
            this.renderWorkItem(workItem);
        });

        new PJQ.Binder(this.$('.work-items'), this.model.workItems, {
            watchElements: [
                'input',
                'textarea'
            ],
            delegate: true,
            modelSelectorAttribute: 'data-cid',
            idAttribute: 'cid',
            modelSelector: '.work-item',
            afterChange: () => {
                this.model.isDirty = true;
            }
        });
    },
    renderWorkItem: function (workItem) {
        this.$('.no-work-items').remove();
        this.$('.work-items-header').removeClass('hidden');
        this.renderSubTemplate(true, this.options.subTemplates.workItem, this.$('.work-items'), {
            model: workItem,
            canEdit: this.options.canEdit
        }, () => {
        });
    },
    renderWorkBy: function () {
        let $contactSelect = this.$('.work-by'),
            $contactName = this.$('.work-log-name');
        if (this.model.workBy != null) {
            $contactName.addClass('hidden');
            $contactSelect.removeClass('hidden');
        } else {
            $contactSelect.addClass('hidden');
            $contactName.removeClass('hidden');
        }
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e);
    },
    calculateTotal: function () {
        let hours = this.model.get('hours'),
            quantity = this.model.get('quantity'),
            overtimeHours = this.model.get('overtimeHours');
        this.$('.work-log-total').text((((hours ? hours : 0) * (quantity ? quantity : 0)) / 100) + ((overtimeHours ? overtimeHours : 0) / 100));
    },
    save: function () {
        if (this.fileUploader.isUploading()) {
            new PJQ.views.BaseModal({
                header: "Files Uploading",
                body: "You can't save while files are uploading"
            });
        } else {
            let cb = () => {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
                this.removeModal();
            }
            if (this.model.hasChanged() || this.model.isNew()) {
                this.model.save(null, {
                    notify: true,
                    success: () => {
                        cb();
                    }
                });
                return;
            }
            cb();
        }
    },
    close: function () {
        if (this.options.canEdit && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.onClose(this.model);
                    this.removeModal();
                }, this)
            });
        } else {
            this.onClose(this.model);
            this.removeModal();
        }
    },
    onDelete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this work log?",
            onDelete: _.bind(function () {
                if (this.options.onDelete) {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});
